import {
  Box,
  Checkbox,
  FormControl,
  FormControlLabel,
  Grid,
  InputAdornment,
  MenuItem,
  Select,
  Stack,
  ListItemText,
  Button,
  TextField,
  Popover,
  TableSortLabel,
} from "@mui/material";
import React, { useEffect, useState, useMemo } from "react";
import Navbar from "../comman/Navbar";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { useTheme } from "@mui/material/styles";
import Sidebar from "../comman/Sidebar";
import CustomerFilterModel from "../model/CustomerFilterModel";
import Typography from "@mui/material/Typography";
import isEqual from "lodash/isEqual";

import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import * as types from "../../redux/action/ActionType";
import { SORT_PARAMS } from "../../redux/action/ActionType";
import {
  GET_ALL_INVOICE_FILTER_URL,
  CREATE_UPDATE_BILLING_STATEMENT_URL,
  GET_ALL_PROJECT_FILTER_URL,
  GET_ALL_INVOICE_STATEMENT_BY_ID_URL,
  UPSERT_INVOICE_STATEMENT_URL,
  GET_ALL_INVOICE_LIST_FILTER_URL,
  GET_PROJECT_DETAILS_BY_ID_URL,
  GET_BROKER_YETOSTART_BILLINGSTATEMENT,
  GET_ADMIN_INVOICE_STATEMENT_BY_ID,
} from "../../constants/ApiRoute";
import {
  authHeader,
  getLogUserId,
  getLogUserRole,
} from "../comman/MainFunction";
import API from "../comman/API";

import Pagination from "@mui/material/Pagination";
import { deCryptFun, enCryptFun } from "../comman/CustomFunction";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import Chip from "@mui/material/Chip";
import IconButton from "@mui/material/IconButton";
import HighlightOffIcon from "@mui/icons-material/HighlightOff";
import { CONSOLIDATED_INVOICE_LIST } from "../../constants/RoutePath";
import UserClearFilter from "../model/UserClearFilter";
import CustomPageLoading from "../comman/CustomPageLoading";
import CreateBillingConfirm from "./CreateBillingConfirm";
import CreateConsolidatedInvoice from "../model/CreateConsolidatedInvoice";
import CreateBillingPeriodInvoice from "../model/CreateBillingPeriodInvoice";
import ViewInvoiceBroker from "../model/viewInvoiceBroker";
import {
  getAllCustomersList,
  getAllProjectsList,
  getPerDiemList,
} from "../../redux/action";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import InvoiceFilter from "../model/InvoiceFilter";
import { useToast } from "../comman/CustomMessages";
import BillingNodata from "../../images/billing-nodata.svg";
import Autocomplete from "@mui/material/Autocomplete";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import Tooltip from "@mui/material/Tooltip";
import NoRecordFound from "../comman/NoRecordFound";
import InvoiceHelpInfoModel from "../model/InvoiceHelpInfoModel";
const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;
import sortupdownarrowIcon from "../../images/sort_up_down_arrow.svg";
import sortuparrowIcon from "../../images/sort_up_arrow.svg";
import sortdownarrowIcon from "../../images/sort_down_arrow.svg";
import ConsolidatedInvoice from "./ConsolidatedInvoice";
import dayjs from "dayjs";
const moment = require("moment");
const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

const filterInitial = {
  customerStatus: "",
  projectStatus: "",
  userId: "",
  projectId: "",
};

const statusOrder = {
  "": -1,
  1: 1,
  2: 2,
  3: 3,
  4: 4,
};

const invoiceFilterInitial = {
  billingStartDateDatepicker: "",
  billingEndDateDatepicker: "",
  billingStartDate: "",
  billingEndDate: "",
  invoiceStatus: "",
};

// Define the status constants
const StatementOpen = "1";
const StatementReady = "2";
const InvoiceStarted = "3";
const InvoiceClosed = "4";

export default function InvoiceList() {
  const currentSort = useSelector((r) => r.SortReducer);
  const [loading, setLoading] = useState(false);
  const invoiceSelectFilter = (state) => state.InvoiceListFilter;
  const consolidateInvoiceListSelect = (state) =>
    state.ConsolidateInvoiceSelect;
  console.log(
    consolidateInvoiceListSelect,
    "ConsolidateInvoiceSelectConsolidateInvoiceSelect"
  );
  const [isInvoiceSearch, setIsInvoiceSearch] = useState(false);
  const showToast = useToast();
  const [page, setPage] = useState(0);
  const theme = useTheme();
  const [projectName, setProjectName] = React.useState([]);
  const [invoiceCheckBox, setInvoiceCheckBox] = React.useState([]);
  console.log(invoiceCheckBox, "invoiceeeeeeecheckboxxxxxxxx");
  const [invoiceCheckBoxAll, setInvoiceCheckBoxAll] = React.useState("");
  const [openFilter, setOpenFilter] = useState(false);
  const [filter, setFilter] = React.useState(filterInitial);
  const [invoicefilter, setInvoicefilter] =
    React.useState(invoiceFilterInitial);
  const [clearFlag, setClearFlag] = useState(false);
  const [clearFiltervalue, setClearFilterValue] = useState(false);
  const [search, setSearch] = React.useState([]);
  const [applyFilterFlag, setApplyFilterFlag] = React.useState(false);
  const [open, setOpen] = useState(false);
  const [userList, setUserList] = useState([]);
  const userListSel = deCryptFun(useSelector((s) => s.AllCustomerListReducer));
  const [filteredProject, setFilteredProject] = useState([]);
  const [selectedProject, setSelectedProjects] = useState([]);
  const dispatch = useDispatch();
  const currentMonthNumber = moment().month() + 1;
  const [InvoiceHelpButton, setInvoiceHelp] = React.useState(false);
  const [consolidatedComponent, setConsoidatedComponent] =
    React.useState(false);
  const reduxFilter = useSelector(invoiceSelectFilter);
  const consoldiateCheckBoxFilter = useSelector(consolidateInvoiceListSelect);
  console.log(
    selectedProject,
    "consoldiateCheckBoxFilterconsoldiateCheckBoxFilter"
  );
  const [billingStatmentLoading, setBillingStatementLoading] = useState(true);
  const [handleInvoiceChangeInvoiceStatus, setHandleChangeInvoiceStatus] =
    useState(false);
  const [checkBoxvalue, setCheckBoxvalue] = useState("");
  const [invoiceOrderBy, setInvoiceOrderBy] = useState("");
  const [invoiceOrder, setInvoiceOrder] = useState("asc");
  const [adminDirectCreation, setAdminDirectCreation] = useState([]);
  const [
    adminSingleInvoiceDirectCreation,
    setAdminSingleInvoiceDirectCreation,
  ] = useState([]);
  const [isClickable, setIsClickable] = useState(true);
  const [periodValues, setPeriodValues] = useState({});
  const [periodIndexValues, setPeriodIndexValues] = useState(0);
  const [invoiceClosedList, setInvoiceClosedList] = useState([]);
  // const projectListSel = deCryptFun(
  //   useSelector((s) => s.AllProjectListReducer)
  // );
  // const projectList = projectListSel ? JSON.parse(projectListSel).data : [];

  const getLogUserRoleArray = JSON.parse(getLogUserRole());
  var getLogUserRoleBoolean = false;
  if (
    getLogUserRoleArray &&
    getLogUserRoleArray.length > 0 &&
    getLogUserRoleArray.includes("Admin")
  ) {
    getLogUserRoleBoolean = true;
  }

  const [periods, setPeriods] = useState([]);
  console.log(periods, "periodssssssssss");
  const [count, setCount] = useState(100);
  const [projectList, setProjectList] = useState([]);
  console.log(projectList, "projectssssssssssss");
  const [projectListDropdown, setProjectListDropdown] = useState([]);

  const [startMonth, setStartMonth] = useState("");
  const [numberOfMonths, setNumberOfMonths] = useState("");
  const [consolidateInvoiceModel, setConsolidateInvoiceModel] = useState(false);
  const [createBillingPeriodModel, setCreateBillingPeriodModel] =
    useState(false);
  const [selectedPeriod, setSelectedPeriod] = useState("");
  const [selectedInvoicePeriod, setSelectedInvoicePeriod] = useState("");
  const [viewInvoiceBrokerModel, setViewInvoiceBrokerModel] = useState("");
  const [viewInvoiceBrokerDetail, setViewInvoiceBrokerDetail] = useState("");
  const navigate = useNavigate();

  const handleFilterChange = (e, val) => {
    const { name, value } = e.target;

    /*
    if (name === "projectId" && value && value.length > 0) {

      const matchedArray =  projectName.filter(item => item == value[0]);

      if(matchedArray && matchedArray.length > 0){

        const updatedArray =  projectName.filter(item => item !== value[0]);
        setProjectName(updatedArray)
        setFilter((prevState) => ({
          ...prevState,
          projectId: updatedArray,
        }));

        const filteredProjects = projectList.filter(project => updatedArray.includes(project.ProjectId));
        setFilteredProject(filteredProjects)

      }else{
        var updatedProjectId = [...projectName,value[0]];
        setProjectName(updatedProjectId)
        setFilter((prevState) => ({
          ...prevState,
          projectId: updatedProjectId,
        }));
        const filteredProjects = projectList.filter(project => updatedProjectId.includes(project.ProjectId));
        setFilteredProject(filteredProjects)
      }
      setBillPeriod(15);
    }
    */

    if (name === "userId") {
      setProjectList([]);
      setProjectListDropdown([]);
      setSelectedProjects([]);
      setFilter((prevState) => ({
        ...prevState,
        userId: value,
        projectId: "",
      }));
      dispatch({
        type: types.INVOICE_LIST_SELECT,
        payload: {
          ...filter,
          userId: value,
          projectId: "", // Assuming 'value' is the new project ID you want to set
          filter: "",
        },
      });

      dispatch({
        type: SORT_PARAMS,
        payload: { order: "", orderBy: "" },
      });

      getProjectList(value, reduxFilter);
    }
  };

  const handleCustomerProjectStatusChange = async (name, val) => {
    setHandleChangeInvoiceStatus(true);
    let value = "";
    if (val === "yes") {
      value = true;
    } else if (val === "no") {
      value = false;
    }
    setCheckBoxvalue(value);
    setSelectedProjects([]);
    setLoading(true); // Set loading to true at the start of the operation

    const updateUserList = () => {
      let userListDropdown = [];
      try {
        userListDropdown = userListSel
          ? JSON.parse(userListSel).data || []
          : [];
      } catch (e) {
        console.error("Failed to parse userListSel:", e);
      }

      if (value === "") {
        setUserList(userListDropdown);
      } else if (value === true) {
        const activeUsers =
          userListDropdown.length > 0
            ? userListDropdown.filter((item) => item.Active === 1)
            : [];
        setUserList(activeUsers);
      } else if (value === false) {
        const inActiveUsers =
          userListDropdown.length > 0
            ? userListDropdown.filter((item) => item.Active === 0)
            : [];
        setUserList(inActiveUsers);
      }
    };

    const updateProjectList = () => {
      if (value === "") {
        setProjectList(projectListDropdown);
      } else if (value === true) {
        const filteredProjects = projectListDropdown.filter(
          (item) => item.Active === 1
        );
        setProjectList(filteredProjects);
      } else if (value === false) {
        const inActiveProjects = projectListDropdown.filter(
          (item) => item.Active === 0
        );
        setProjectList(inActiveProjects);
      }
    };

    if (name === "customerStatus") {
      setFilter((prevState) => ({
        ...prevState,
        userId: "",
        projectId: "",
        projectStatus: "",
      }));
      dispatch({
        type: types.INVOICE_LIST_SELECT,
        payload: {
          ...filter,
          userId: "",
          projectId: "", // Assuming 'value' is the new project ID you want to set
          filter: "",
          projectStatus: "",
        },
      });
      setProjectList([]);
      setProjectListDropdown([]);
      dispatch(getAllCustomersList());
      updateUserList();
    } else if (name === "projectStatus") {
      setFilter((prevState) => ({
        ...prevState,
        projectId: "",
      }));
      if (filter.userId != "") {
        getProjectList(filter.userId, filter);
      }
      updateProjectList();
    }

    setFilter((prevState) => ({
      ...prevState,
      [name]: value,
    }));
    dispatch({
      type: types.INVOICE_LIST_SELECT,
      payload: {
        ...filter,
        [name]: value, // Assuming 'value' is the new project ID you want to set
        filter: "",
      },
    });

    dispatch({
      type: types?.CONSOLIDATE_INVOICE_LIST_SELECT,
      payload: {
        matchedData: [],
        invoiceAllSelectCheckbox: "",
        invoiceSingleCheckBox: "",
        userList: [],
        periods: periods,
      },
    });

    dispatch({
      type: SORT_PARAMS,
      payload: { order: "", orderBy: "" },
    });

    setLoading(false); // Reset loading to false after all updates are done
  };

  // JSX
  <FormControlLabel
    className="checkbox"
    control={
      <Checkbox
        name="customerStatus"
        onChange={() =>
          handleCustomerProjectStatusChange("customerStatus", "no")
        }
        checked={filter.customerStatus === false ? true : false}
        sx={{ color: "gray" }}
      />
    }
    label="Inactive"
  />;

  {
    loading && <CustomPageLoading />;
  }

  const handleInvoiceCheckBoxChange = (val) => {
    var valueType = typeof val;

    console.log(val, "valllllllllllll", valueType);

    const matchedArrayAll = periods
      .filter((item) => {
        if (item.StatusId) {
          var StatusIdArray = item.StatusId.split(",");
          let trimmedStatusArr = StatusIdArray.map((str) => str.trim());
          let containsOne = trimmedStatusArr.includes("2");
          //let containsTwo = trimmedStatusArr.includes('2');
          //return containsOne || containsTwo;
          return containsOne;
        }
        return false;
      })
      .map((item) => item.BillingStatemrntId);

    if (
      ((invoiceCheckBox == "" && invoiceCheckBoxAll === "") ||
        typeof invoiceCheckBox == "object") &&
      val == "all"
    ) {
      const matchedArray = periods
        .filter((item) => {
          if (item.StatusId) {
            var StatusIdArray = item.StatusId.split(",");
            let trimmedStatusArr = StatusIdArray.map((str) => str.trim());
            let containsOne = trimmedStatusArr.includes("2");
            //let containsTwo = trimmedStatusArr.includes('2');
            //return containsOne || containsTwo;
            return containsOne;
          }
          return false;
        })
        .map((item) => item.BillingStatemrntId);

      console.log("setInvoiceCheckBox ONE", matchedArray);

      setInvoiceCheckBox(matchedArray);
      setInvoiceCheckBoxAll(val);
      dispatch({
        type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
        payload: {
          ...consoldiateCheckBoxFilter,
          invoiceSingleCheckBox: matchedArray,
          invoiceAllSelectCheckbox: val,
        },
      });
    } else if (valueType === "number") {
      setInvoiceCheckBoxAll("");
      dispatch({
        type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
        payload: {
          ...consoldiateCheckBoxFilter,
          invoiceAllSelectCheckbox: "",
        },
      });
      if (typeof invoiceCheckBox === "string") {
        console.log("setInvoiceCheckBox TWO", [val]);

        setInvoiceCheckBox([val]);
        dispatch({
          type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
          payload: {
            ...consoldiateCheckBoxFilter,
            invoiceSingleCheckBox: [val],
          },
        });
      }
      if (typeof invoiceCheckBox === "object") {
        const matchedArray = invoiceCheckBox.filter((item) => item == val);

        if (matchedArray && matchedArray.length > 0) {
          const updatedArray = invoiceCheckBox.filter((item) => item !== val);

          console.log("setInvoiceCheckBox THREE", updatedArray);

          setInvoiceCheckBox(updatedArray);
          dispatch({
            type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
            payload: {
              ...consoldiateCheckBoxFilter,
              invoiceSingleCheckBox: updatedArray,
            },
          });
        } else {
          console.log("matchedArrayAllNewOne ", matchedArrayAll, [
            ...invoiceCheckBox,
            val,
          ]);

          if ([...invoiceCheckBox, val].length == matchedArrayAll.length) {
            setInvoiceCheckBoxAll("all");
            dispatch({
              type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
              payload: {
                ...consoldiateCheckBoxFilter,
                invoiceAllSelectCheckbox: "all",
              },
            });
          }
          setInvoiceCheckBox([...invoiceCheckBox, val]);

          console.log("setInvoiceCheckBox THREE", [...invoiceCheckBox, val]);

          dispatch({
            type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
            payload: {
              ...consoldiateCheckBoxFilter,
              invoiceSingleCheckBox: [...invoiceCheckBox, val],
            },
          });
        }
      }
    }

    if (invoiceCheckBoxAll === "all" && valueType === "string") {
      setInvoiceCheckBox("");
      setInvoiceCheckBoxAll("");
      dispatch({
        type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
        payload: {
          ...consoldiateCheckBoxFilter,
          invoiceSingleCheckBox: "",
          invoiceAllSelectCheckbox: "",
        },
      });
    }
  };

  useEffect(() => {
    dispatch(getAllCustomersList());
  }, [dispatch]);

  useEffect(() => {
    const matchedArrayAll =
      consoldiateCheckBoxFilter.periods &&
      consoldiateCheckBoxFilter.periods
        .filter((item) => {
          if (item.StatusId) {
            const trimmedStatusArr = item.StatusId.split(",").map((str) =>
              str.trim()
            );
            return trimmedStatusArr.includes("2"); // Check if "2" is included
          }
          return false;
        })
        .map((item) => item.BillingStatemrntId);

    console.log(
      "invoiceCheckBoxAllinvoiceCheckBoxAll",
      consoldiateCheckBoxFilter,
      invoiceCheckBoxAll,
      matchedArrayAll
    );

    if (invoiceCheckBox?.length == 0) {
      setInvoiceCheckBox(consoldiateCheckBoxFilter?.invoiceSingleCheckBox);
    } else {
      if (
        matchedArrayAll &&
        consoldiateCheckBoxFilter &&
        consoldiateCheckBoxFilter.invoiceSingleCheckBox &&
        matchedArrayAll.length != 0 &&
        matchedArrayAll.length ==
          consoldiateCheckBoxFilter.invoiceSingleCheckBox.length
      ) {
        setInvoiceCheckBoxAll("all");
      } else {
        setInvoiceCheckBoxAll("");
      }
    }
  }, [invoiceCheckBox, invoiceCheckBoxAll, selectedProject]);

  useEffect(() => {
    if (
      userListSel &&
      JSON.parse(userListSel).data &&
      JSON.parse(userListSel).data.length > 0
    ) {
      setUserList(JSON.parse(userListSel).data && JSON.parse(userListSel).data);
    }
  }, [userListSel]);

  const getProjectList = async (customerId, reduxFilter) => {
    console.log(reduxFilter.projectStatus, "reduxFilterjshjshdjh");
    if (customerId) {
      let data = {
        count: count,
        offset: page,
        customerId: customerId,
      };

      const config = {
        method: "GET",
        url: GET_ALL_PROJECT_FILTER_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(data)),
        },
      };

      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);

        if (parsedResponse.data && parsedResponse.data.length > 0) {
          const filteredData = parsedResponse.data.map((item) => ({
            Name: item.Name,
            ProjectId: item.ProjectId,
            BillingPeriod: item.BillingPeriod,
            Active: item.Active,
            BrokerCount: item.BrokerCount,
          }));
          setProjectList(filteredData);
          setProjectListDropdown(filteredData);
        } else {
          setProjectList([]);
          setProjectListDropdown([]);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          showToast(v.message, "error");
        }
        // return null; // Return null on error
      }
    } else {
      setProjectList([]);
      setProjectListDropdown([]);
    }
  };

  const getInvoiceFilterList = async () => {
    const selectedProjectNew =
      projectList &&
      projectList.length > 0 &&
      projectList.filter((element) =>
        reduxFilter?.projectId.includes(element?.ProjectId)
      );

    if (selectedProjectNew && selectedProjectNew.length > 0) {
      selectedProjectNew.sort((a, b) => {
        return (
          reduxFilter.projectId.indexOf(a.ProjectId) -
          reduxFilter.projectId.indexOf(b.ProjectId)
        );
      });
    }

    if (filter.userId && filter.projectId && filter.projectId.length > 0) {
      try {
        setLoading(true);
        const billingStatementData = await getInvoiceFilterAPIList();

        console.log("billingStatementData", billingStatementData);

        if (billingStatementData) {
          const numberOfMonthsVal = 7;
          // Ensure billPeriodVal is in the correct format
          const billPeriodVal = selectedProjectNew;

          const startMonthVal = getFutureMonth(
            currentMonthNumber,
            numberOfMonthsVal
          );

          const generatedPeriods = await generateBillingPeriods(
            startMonthVal,
            numberOfMonthsVal,
            billPeriodVal, // Ensure this matches the expected format
            billingStatementData
          );
          const generatedPeriods1 = await generateBillingPeriods1(
            invoicefilter,
            billPeriodVal, // Ensure this matches the expected format
            billingStatementData
          );
          console.log(generatedPeriods1, "generatedPeriodsgeneratedPeriods");
          console.log(
            generatedPeriods,
            "g11111eneratedPeriodsgeneratedPeriods"
          );
          var PeriodKeyParams = await convertToProjPeriodFormat(
            generatedPeriods
          );
          var PeriodKeyParams1 = await convertToProjPeriodFormat1(
            generatedPeriods1
          );

          const notYetStartedObjResponse = await notYetStartedObjFunc(
            PeriodKeyParams
          );
          const notYetStartedObjResponse1 = await notYetStartedObjFunc1(
            PeriodKeyParams1
          );

          console.log(
            notYetStartedObjResponse,
            "notYetStartedObjResponsenotYetStartedObjResponse"
          );
          generatedPeriods.forEach((listItem) => {
            const matchingInput = notYetStartedObjResponse.find(
              (inputItem) =>
                inputItem.PeriodKey === listItem.PeriodKey &&
                inputItem.ProjID === listItem.ProjectID
            );

            if (matchingInput) {
              listItem.isNotYetStarted = true;
              listItem.notYetStartedDetail = matchingInput;
            } else {
              listItem.isNotYetStarted = false;
              listItem.notYetStartedDetail = null;
            }
          });
          generatedPeriods1.forEach((listItem) => {
            const matchingInput = notYetStartedObjResponse1.find(
              (inputItem) =>
                inputItem.PeriodKey === listItem.PeriodKey &&
                inputItem.ProjID === listItem.ProjectID
            );

            if (matchingInput) {
              listItem.isNotYetStarted = true;
              listItem.notYetStartedDetail = matchingInput;
            } else {
              listItem.isNotYetStarted = false;
              listItem.notYetStartedDetail = null;
            }
          });

          if (
            (invoicefilter.billingStartDate && invoicefilter.billingEndDate) ||
            invoicefilter.invoiceStatus
          ) {
            dispatch({
              type: types.INVOICE_LIST_SELECT,
              payload: {
                ...filter,
                filter: {
                  billingStartDateDatepicker:
                    invoicefilter.billingStartDateDatepicker,
                  billingEndDateDatepicker:
                    invoicefilter.billingEndDateDatepicker,
                  billingStartDate: invoicefilter.billingStartDate,
                  billingEndDate: invoicefilter.billingEndDate,
                  invoiceStatus: invoicefilter.invoiceStatus,
                },
              },
            });

            var filteredData = [];

            if (
              invoicefilter.billingStartDate &&
              invoicefilter.billingEndDate &&
              !invoicefilter.invoiceStatus
            ) {
              const filterStartDate = moment(
                invoicefilter.billingStartDate,
                "YYYY-MM-DD"
              ).valueOf();
              const filterEndDate = moment(
                invoicefilter.billingEndDate,
                "YYYY-MM-DD"
              ).valueOf();

              filteredData = generatedPeriods1.filter((item) => {
                // const itemStartDateMoment = moment(item.BillingStart,"D/M/YYYY");
                const itemStartDate = moment(item.BillingStart).valueOf();
                // const itemEndDateMoment = moment(item.BillingEnd, "D/M/YYYY");
                const itemEndDate = moment(item.BillingEnd).valueOf();

                console.log("invoicefilter FilterVal", invoicefilter);
                console.log(
                  "invoicefilter itemStartDateMoment",
                  item.BillingStart,
                  item.BillingEnd
                );
                console.log(
                  "invoicefilter itemStartDate",
                  itemStartDate,
                  filterEndDate
                );
                console.log(
                  "invoicefilter itemEndDate",
                  itemEndDate,
                  filterStartDate
                );

                return (
                  itemStartDate <= filterEndDate &&
                  itemEndDate >= filterStartDate
                );
              });
              console.log(filteredData, "filteredDatafilteredData");
            } else if (
              !invoicefilter.billingStartDate &&
              !invoicefilter.billingEndDate &&
              invoicefilter.invoiceStatus
            ) {
              console.log("invoicefilter1", invoicefilter);
              console.log("invoicefilter2", generatedPeriods1);

              filteredData = generatedPeriods.filter((item) => {
                return item.StatusId.includes(invoicefilter.invoiceStatus);
              });
            } else if (
              invoicefilter.billingStartDate &&
              invoicefilter.billingEndDate &&
              invoicefilter.invoiceStatus
            ) {
              const filterStartDate = moment(
                invoicefilter.billingStartDate,
                "YYYY-MM-DD"
              ).valueOf();
              const filterEndDate = moment(
                invoicefilter.billingEndDate,
                "YYYY-MM-DD"
              ).valueOf();

              filteredData = generatedPeriods1.filter((item) => {
                const itemStartDate = moment(item.BillingStart).valueOf();
                const itemEndDate = moment(item.BillingEnd).valueOf();

                return (
                  itemStartDate <= filterEndDate &&
                  itemEndDate >= filterStartDate &&
                  item.StatusId.includes(invoicefilter.invoiceStatus)
                );
              });
            }

            setPeriods(filteredData);
            console.log(filteredData, "filtereeeeeeeeee");
            dispatch({
              type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
              payload: {
                ...consoldiateCheckBoxFilter,
                periods: filteredData,
              },
            });
          } else {
            setPeriods(generatedPeriods);
            console.log(generatedPeriods, "generatedPeriodsfiltereeeeeeeeee");
            dispatch({
              type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
              payload: {
                ...consoldiateCheckBoxFilter,
                periods: generatedPeriods,
              },
            });
          }

          setSelectedProjects(selectedProjectNew);
          setIsInvoiceSearch(true);
          setLoading(false);
        }
      } catch (error) {
        console.error("Error fetching billing details:", error);
      }
    } else {
      setIsInvoiceSearch(false);
    }
  };

  const convertToProjPeriodFormat = (data) => {
    // Group data by ProjectID
    const grouped = data.reduce((acc, curr) => {
      const projectId = curr.ProjectID.toString();
      const periodKey = curr.PeriodKey;

      if (!acc[projectId]) {
        acc[projectId] = [];
      }
      acc[projectId].push(periodKey);
      return acc;
    }, {});

    // Convert grouped data into the desired format
    const projPeriod = Object.keys(grouped).map((projectId) => ({
      projectId: projectId,
      periodKey: grouped[projectId].join(","),
    }));

    return {
      projPeriod,
      statusId: 0,
    };
  };
  const convertToProjPeriodFormat1 = (data) => {
    // Group data by ProjectID
    const grouped = data.reduce((acc, curr) => {
      const projectId = curr.ProjectID.toString();
      const periodKey = curr.PeriodKey;

      if (!acc[projectId]) {
        acc[projectId] = [];
      }
      acc[projectId].push(periodKey);
      return acc;
    }, {});

    // Convert grouped data into the desired format
    const projPeriod = Object.keys(grouped).map((projectId) => ({
      projectId: projectId,
      periodKey: grouped[projectId].join(","),
    }));

    return {
      projPeriod,
      statusId: 0,
    };
  };

  const notYetStartedObjFunc = async (notYetStartedObjInput) => {
    const configProjectConfig = {
      method: "GET",
      headers: authHeader(),
      url: GET_BROKER_YETOSTART_BILLINGSTATEMENT,
      params: {
        webString: enCryptFun(JSON.stringify(notYetStartedObjInput)),
      },
    };
    try {
      const response = await API(configProjectConfig);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (
        parsedResponse.status === "Success" &&
        parsedResponse.BrokerYetToStartDetails &&
        parsedResponse.BrokerYetToStartDetails.length > 0
      ) {
        return parsedResponse.BrokerYetToStartDetails;
        console.log(
          "parsedResponse-->",
          parsedResponse.BrokerYetToStartDetails
        );
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  };

  const notYetStartedObjFunc1 = async (notYetStartedObjInput) => {
    const configProjectConfig = {
      method: "GET",
      headers: authHeader(),
      url: GET_BROKER_YETOSTART_BILLINGSTATEMENT,
      params: {
        webString: enCryptFun(JSON.stringify(notYetStartedObjInput)),
      },
    };
    try {
      const response = await API(configProjectConfig);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (
        parsedResponse.status === "Success" &&
        parsedResponse.BrokerYetToStartDetails &&
        parsedResponse.BrokerYetToStartDetails.length > 0
      ) {
        return parsedResponse.BrokerYetToStartDetails;
      } else {
        return [];
      }
    } catch (error) {
      return [];
    }
  };

  const getInvoiceFilterAPIList = async () => {
    if (filter.userId && filter.projectId && filter.projectId.length > 0) {
      const { userId, projectId } = filter;
      const { billingStartDate, billingEndDate, invoiceStatus } = invoicefilter;

      let data = {
        count: count,
        offset: page,
      };

      // if (getLogUserRoleBoolean) {
      //   data.isOrphaned = getLogUserRoleBoolean;
      // }

      if (userId) {
        data.customerId = userId;
      }

      if (projectId && projectId.length > 0) {
        data.projectId = projectId.join(",");
        //data.projectId = projectId[0];
      }

      // if (applyFilterFlag) {
      //   if (billingStartDate) {
      //     data.billingStart = billingStartDate;
      //   }

      //   if (billingEndDate) {
      //     data.billingEnd = billingEndDate;
      //   }

      //   if (invoiceStatus) {
      //     // if (invoiceStatus == 4) {
      //     //   data.status = 3;
      //     // } else {
      //     data.status = invoiceStatus;
      //     // }
      //   }
      // }

      const config = {
        method: "GET",
        url: GET_ALL_INVOICE_FILTER_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(data)),
        },
      };

      // console.log("data-input", data)

      let consolidateInvoiceFilter = {
        count: count,
        offset: page,
      };

      if (userId) {
        consolidateInvoiceFilter.customerId = userId;
      }

      if (projectId && projectId.length > 0) {
        consolidateInvoiceFilter.consolidatedProjIDs = projectId.join(",");
      }

      // if (applyFilterFlag) {
      //   if (billingStartDate) {
      //     consolidateInvoiceFilter.consolidatedBillingStarts = billingStartDate;
      //   }

      //   if (billingEndDate) {
      //     consolidateInvoiceFilter.consolidatedBillingEnds = billingEndDate;
      //   }
      //   if (invoiceStatus) {
      //     // if (invoiceStatus == 4) {
      //     //   data.status = 3;
      //     // } else {
      //     consolidateInvoiceFilter.status = invoiceStatus;
      //     // }
      //   }
      // }

      const configConsolidate = {
        method: "GET",
        url: GET_ALL_INVOICE_LIST_FILTER_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(consolidateInvoiceFilter)),
        },
      };

      let dataClosed = {
        count: count,
        offset: page,
      };

      // if (getLogUserRoleBoolean) {
      //   data.isOrphaned = getLogUserRoleBoolean;
      // }

      if (userId) {
        dataClosed.customerId = userId;
      }

      if (projectId && projectId.length > 0) {
        dataClosed.projectId = projectId.join(",");
        //data.projectId = projectId[0];
      }

      // if (applyFilterFlag) {
      //   if (billingStartDate) {
      //     dataClosed.billingStart = billingStartDate;
      //   }

      //   if (billingEndDate) {
      //     dataClosed.billingEnd = billingEndDate;
      //   }
      //   if (invoiceStatus) {
      //     // if (invoiceStatus == 4) {
      //     //   dataClosed.status = 3;
      //     // } else {
      //     dataClosed.status = invoiceStatus;
      //     // }
      //   }
      // }

      const configClosed = {
        method: "GET",
        url: GET_ALL_INVOICE_LIST_FILTER_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(dataClosed)),
        },
      };

      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          //Direct invoice & Closed invoice
          const responseClosed = await API(configClosed);
          let decryptedResponseClosed = deCryptFun(responseClosed.data);
          const parsedResponseClosed = JSON.parse(decryptedResponseClosed);

          // Consolidate invoice
          const responseConsolidateInvoice = await API(configConsolidate);
          let decryptedResponseConsolidateInvoice = deCryptFun(
            responseConsolidateInvoice.data
          );
          const parsedResponseConsolidateInvoice = JSON.parse(
            decryptedResponseConsolidateInvoice
          );

          console.log(
            " parsedResponse consolidate --> ",
            parsedResponseConsolidateInvoice
          );
          console.log(
            " parsedResponse direct Closed --> ",
            parsedResponseClosed
          );
          console.log(" parsedResponse normal --> ", parsedResponse);

          if (
            (parsedResponse.data && parsedResponse.data.length > 0) ||
            parsedResponseClosed.data.length > 0
          ) {
            const b = parsedResponse.data ? parsedResponse.data : [];
            const a = parsedResponseClosed.data
              ? parsedResponseClosed.data
              : [];
            const c = parsedResponseConsolidateInvoice.data
              ? parsedResponseConsolidateInvoice.data
              : [];

            console.log("invoicelistWWW -> normal", b);
            console.log("invoicelistWWW -> direct and close", a);
            console.log("invoicelistWWW -> consoldate", c);

            const updatedB = [...b];

            // Combained  Invoice Cloded List

            const invoiceClosedArray = a
              .filter(
                (val) => val.StatusID == 4 && val.BillingStatementIDs != "0"
              )
              .map((val2) => ({
                invoiceId: val2.InvoiceId,
                BillingStatementIDs: val2.BillingStatementIDs,
                ProjectID: val2.ProjectID,
                ConsolidatedProjIDs: val2.ConsolidatedProjIDs,
                PeriodKey: val2.PeriodKey,
                ConsolidatedPeriodKeys: val2.ConsolidatedPeriodKeys,
              }));

            const invoiceConsolidateArray = c
              .filter(
                (val) => val.StatusID == 4 && val.BillingStatementIDs != "0"
              )
              .map((val2) => ({
                invoiceId: val2.InvoiceId,
                BillingStatementIDs: val2.BillingStatementIDs,
                ProjectID: val2.ProjectID,
                ConsolidatedProjIDs: val2.ConsolidatedProjIDs,
                PeriodKey: val2.PeriodKey,
                ConsolidatedPeriodKeys: val2.ConsolidatedPeriodKeys,
              }));

            const combinedArray = invoiceClosedArray.concat(
              invoiceConsolidateArray
            );

            if (combinedArray && combinedArray.length > 0) {
              setInvoiceClosedList(combinedArray);
            }

            console.log("combinedArraycombinedArray", combinedArray);

            if (
              parsedResponseClosed.data &&
              parsedResponseClosed.data.length > 0
            ) {
              a.forEach((itemA) => {
                if (
                  itemA.StatusID === 4 &&
                  itemA.BillingStatementIDs &&
                  itemA.BillingStatementIDs != 0
                ) {
                  updatedB.forEach((itemupdatedBA) => {
                    const statusIds = itemupdatedBA.StatusId.split(",").map(
                      (id) => id.trim()
                    );
                    const statmentIds = itemupdatedBA.statmentIds
                      .split(",")
                      .map((id) => id.trim());

                    const statusCounts = { ...itemupdatedBA.statusCounts };

                    var BillingStatementIDArray = itemA.BillingStatementIDs
                      ? itemA.BillingStatementIDs.split(",")
                      : null;

                    statusIds.forEach((id, index) => {
                      if (
                        id === "3" &&
                        BillingStatementIDArray &&
                        BillingStatementIDArray.length > 0 &&
                        BillingStatementIDArray.includes(statmentIds[index])
                      ) {
                        statusIds[index] = "4";
                        statusCounts["Invoice Started"]--;
                        statusCounts["Invoice Closed"]++;
                      }
                    });

                    itemupdatedBA.StatusId = statusIds.join(",");
                    itemupdatedBA.statusCounts = statusCounts;
                    itemupdatedBA["InvoiceId"] = itemA.invoiceId;
                  });
                }
              });
            }

            if (
              parsedResponseConsolidateInvoice.data &&
              parsedResponseConsolidateInvoice.data.length > 0
            ) {
              c.forEach(function (itemB) {
                if (
                  itemB.IsConsolidated &&
                  itemB.BillingStatementIDs &&
                  itemB.BillingStatementIDs != 0
                ) {
                  updatedB.forEach((itemupdatedBB) => {
                    if (itemB.StatusID == 4) {
                      const ConsolidatedStatusIds =
                        itemupdatedBB.StatusId.split(",").map((id) =>
                          id.trim()
                        );
                      const ConsolidatedStatmentIds = itemupdatedBB.statmentIds
                        .split(",")
                        .map((id) => id.trim());

                      const ConsolidatedStatusCounts = {
                        ...itemupdatedBB.statusCounts,
                      };

                      var ConsolidatedBillingStatementIDArray =
                        itemB.BillingStatementIDs
                          ? itemB.BillingStatementIDs.split(",")
                          : null;

                      ConsolidatedStatusIds.forEach((id, index) => {
                        if (
                          id === "3" &&
                          ConsolidatedBillingStatementIDArray &&
                          ConsolidatedBillingStatementIDArray.length > 0 &&
                          ConsolidatedBillingStatementIDArray.includes(
                            ConsolidatedStatmentIds[index]
                          )
                        ) {
                          ConsolidatedStatusIds[index] = "4";
                          ConsolidatedStatusCounts["Invoice Started"]--;
                          ConsolidatedStatusCounts["Invoice Closed"]++;
                        }
                      });

                      itemupdatedBB.StatusId = ConsolidatedStatusIds.join(",");
                      itemupdatedBB.statusCounts = ConsolidatedStatusCounts;
                    }
                    itemupdatedBB["InvoiceId"] = itemB.InvoiceId;
                    itemupdatedBB["IsConsolidated"] = itemB.IsConsolidated;
                  });
                }
              });
            }

            console.log("updatedBupdatedB", updatedB);

            return updatedB && updatedB.length > 0
              ? getfinalBackend(updatedB)
              : [];
          } else {
            return parsedResponse.data;
          }

          // setPeriods(parsedResponse.data);
          // setIsInvoiceSearch(true);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          showToast(v.message, "error");
        }
        return [];
      }
    } else {
      return [];
    }
  };

  const getfinalBackend = (updatedB) => {
    var finalUpdatedB = [];
    var matchedArrayForRemove = [];

    // Filter out billing statements
    const arrWithOutBilingStatement = updatedB.filter(
      (item) => !item.BillingStatemrntId || item.BillingStatemrntId == 0
    );

    // Filter in billing statements
    const arrWithBilingStatement = updatedB.filter(
      (item) => item.BillingStatemrntId && item.BillingStatemrntId != 0
    );

    console.log(
      "arrWithOutBilingStatementarrWithOutBilingStatement",
      arrWithOutBilingStatement
    );
    console.log(
      "arrWithBilingStatementarrWithBilingStatement",
      arrWithBilingStatement
    );

    if (arrWithOutBilingStatement && arrWithOutBilingStatement.length > 0) {
      arrWithBilingStatement.forEach((billing) => {
        const matchingInvoices = arrWithOutBilingStatement.filter(
          (invoice) =>
            invoice.ProjectID === billing.ProjectID &&
            invoice.PeriodKey === billing.PeriodKey
        );

        if (matchingInvoices && matchingInvoices.length > 0) {
          for (const valMatch of matchingInvoices) {
            let invoiceStatusCounts = valMatch.statusCounts;
            let finalCounts = { ...billing.statusCounts };

            for (let key in invoiceStatusCounts) {
              if (invoiceStatusCounts.hasOwnProperty(key)) {
                // Sum the values from both objects
                finalCounts[key] =
                  (finalCounts[key] || 0) + (valMatch.statusCounts[key] || 0);
              }
            }

            const mergedItem = {
              ...billing,
              statmentIds: billing.statmentIds
                ? `${billing.statmentIds}, 0`
                : "0",
              Status: `${billing.Status}, ${valMatch.Status}`,
              StatusId: `${billing.StatusId}, ${valMatch.StatusId}`,
              statusCounts: finalCounts,
            };

            finalUpdatedB.push(mergedItem);

            matchedArrayForRemove.push({
              ProjectID: valMatch.ProjectID,
              PeriodKey: valMatch.PeriodKey,
            });
          }
        } else {
          finalUpdatedB.push(billing);
        }
      });

      const unmatched = arrWithOutBilingStatement.filter((income) => {
        return !matchedArrayForRemove.find(
          (match) =>
            match.ProjectID === income.ProjectID &&
            match.PeriodKey === income.PeriodKey
        );
      });

      if (unmatched && unmatched.length > 0) {
        finalUpdatedB.push(...unmatched);
      }
    } else {
      finalUpdatedB = arrWithBilingStatement;
    }

    // finalUpdatedB.push(...arrWithOutBilingStatement);

    return finalUpdatedB;
  };

  const getInvoiceFilterAPIListOld = async () => {
    if (filter.userId && filter.projectId && filter.projectId.length > 0) {
      const { userId, projectId } = filter;
      const { billingStartDate, billingEndDate, invoiceStatus } = invoicefilter;

      let data = {
        count: count,
        offset: page,
      };

      // if (getLogUserRoleBoolean) {
      //   data.isOrphaned = getLogUserRoleBoolean;
      // }

      if (userId) {
        data.customerId = userId;
      }

      if (projectId && projectId.length > 0) {
        data.projectId = projectId.join(",");
        //data.projectId = projectId[0];
      }

      // if (applyFilterFlag) {
      //   if (billingStartDate) {
      //     data.billingStart = billingStartDate;
      //   }

      //   if (billingEndDate) {
      //     data.billingEnd = billingEndDate;
      //   }

      //   if (invoiceStatus) {
      //     // if (invoiceStatus == 4) {
      //     //   data.status = 3;
      //     // } else {
      //     data.status = invoiceStatus;
      //     // }
      //   }
      // }

      const config = {
        method: "GET",
        url: GET_ALL_INVOICE_FILTER_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(data)),
        },
      };

      // console.log("data-input", data)

      let consolidateInvoiceFilter = {
        count: count,
        offset: page,
      };

      if (userId) {
        consolidateInvoiceFilter.customerId = userId;
      }

      if (projectId && projectId.length > 0) {
        consolidateInvoiceFilter.consolidatedProjIDs = projectId.join(",");
      }

      // if (applyFilterFlag) {
      //   if (billingStartDate) {
      //     consolidateInvoiceFilter.consolidatedBillingStarts = billingStartDate;
      //   }

      //   if (billingEndDate) {
      //     consolidateInvoiceFilter.consolidatedBillingEnds = billingEndDate;
      //   }
      //   if (invoiceStatus) {
      //     // if (invoiceStatus == 4) {
      //     //   data.status = 3;
      //     // } else {
      //     consolidateInvoiceFilter.status = invoiceStatus;
      //     // }
      //   }
      // }

      const configConsolidate = {
        method: "GET",
        url: GET_ALL_INVOICE_LIST_FILTER_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(consolidateInvoiceFilter)),
        },
      };

      let dataClosed = {
        count: count,
        offset: page,
      };

      // if (getLogUserRoleBoolean) {
      //   data.isOrphaned = getLogUserRoleBoolean;
      // }

      if (userId) {
        dataClosed.customerId = userId;
      }

      if (projectId && projectId.length > 0) {
        dataClosed.projectId = projectId.join(",");
        //data.projectId = projectId[0];
      }

      // if (applyFilterFlag) {
      //   if (billingStartDate) {
      //     dataClosed.billingStart = billingStartDate;
      //   }

      //   if (billingEndDate) {
      //     dataClosed.billingEnd = billingEndDate;
      //   }
      //   if (invoiceStatus) {
      //     // if (invoiceStatus == 4) {
      //     //   dataClosed.status = 3;
      //     // } else {
      //     dataClosed.status = invoiceStatus;
      //     // }
      //   }
      // }

      const configClosed = {
        method: "GET",
        url: GET_ALL_INVOICE_LIST_FILTER_URL,
        headers: authHeader(),
        params: {
          webString: enCryptFun(JSON.stringify(dataClosed)),
        },
      };

      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          //Direct invoice & Closed invoice
          const responseClosed = await API(configClosed);
          let decryptedResponseClosed = deCryptFun(responseClosed.data);
          const parsedResponseClosed = JSON.parse(decryptedResponseClosed);

          // Consolidate invoice
          const responseConsolidateInvoice = await API(configConsolidate);
          let decryptedResponseConsolidateInvoice = deCryptFun(
            responseConsolidateInvoice.data
          );
          const parsedResponseConsolidateInvoice = JSON.parse(
            decryptedResponseConsolidateInvoice
          );

          //  console.log(" parsedResponse consolidate --> ", parsedResponseConsolidateInvoice)
          //  console.log(" parsedResponse direct Closed --> ", parsedResponseClosed)
          //  console.log(" parsedResponse normal --> ", parsedResponse)

          if (parsedResponse.data && parsedResponse.data.length > 0) {
            const b = parsedResponse.data;
            const a = parsedResponseClosed.data;
            const c = parsedResponseConsolidateInvoice.data;

            console.log("invoice list -> normal", b);
            console.log("invoice list -> direct and close", a);
            console.log("invoice list -> consoldate", c);

            const updatedB = [...b];

            if (
              parsedResponseClosed.data &&
              parsedResponseClosed.data.length > 0
            ) {
              a.forEach((itemA) => {
                if (itemA.StatusID === 4) {
                  const matchingBIndex = updatedB.findIndex(
                    (itemB) =>
                      itemB.ProjectID === itemA.ProjectID &&
                      itemB.PeriodKey === itemA.PeriodKey
                  );

                  if (matchingBIndex !== -1) {
                    const itemBToUpdate = { ...updatedB[matchingBIndex] };
                    const statusIds = itemBToUpdate.StatusId.split(",").map(
                      (id) => id.trim()
                    );
                    const statmentIds = itemBToUpdate.statmentIds
                      .split(",")
                      .map((id) => id.trim());

                    var BillingStatementIDArray = itemA.BillingStatementIDs
                      ? itemA.BillingStatementIDs.split(",")
                      : null;

                    const statusCounts = { ...itemBToUpdate.statusCounts };

                    statusIds.forEach((id, index) => {
                      if (id === "3" && !BillingStatementIDArray) {
                        statusIds[index] = "4";
                        statusCounts["Invoice Started"]--;
                        statusCounts["Invoice Closed"]++;
                      }

                      if (
                        id === "3" &&
                        BillingStatementIDArray &&
                        BillingStatementIDArray.length > 0 &&
                        BillingStatementIDArray.includes(statmentIds[index])
                      ) {
                        statusIds[index] = "4";
                        statusCounts["Invoice Started"]--;
                        statusCounts["Invoice Closed"]++;
                      }
                    });

                    itemBToUpdate.StatusId = statusIds.join(",");
                    itemBToUpdate.statusCounts = statusCounts;
                    itemBToUpdate["InvoiceId"] = itemA.InvoiceId;

                    updatedB[matchingBIndex] = itemBToUpdate;
                  }
                } else if (itemA.StatusID === 3 && itemA.InvoiceId) {
                  const matchingDirectIndex = updatedB.findIndex(
                    (itemB) =>
                      itemB.ProjectID == itemA.ProjectID &&
                      itemB.PeriodKey != itemA.PeriodKey &&
                      !itemA.BillingStatementIDs
                  );

                  if (matchingDirectIndex !== -1) {
                    let Obj = {
                      InvoiceId: itemA.InvoiceId,
                      BillingStatemrntId: null,
                      statmentIds: "",
                      ProjectID: itemA.ProjectID,
                      CustomerID: itemA.CustomerID,
                      ProjectName: itemA.ProjectNames,
                      BillingStart: itemA.BillingStart,
                      BillingEnd: itemA.BillingEnd,
                      BrokerCount: 0,
                      Status: "Invoice Started",
                      PeriodKey: itemA.PeriodKey,
                      StatusId: "3",
                      statusCounts: {
                        "Statement Open": 0,
                        "Statement Ready": 0,
                        "Invoice Started": 1,
                        "Invoice Closed": 0,
                      },
                    };

                    updatedB.push(Obj);
                  }
                }
              });
            }

            if (
              parsedResponseConsolidateInvoice.data &&
              parsedResponseConsolidateInvoice.data.length > 0
            ) {
              c.forEach(function (item) {
                let ConsolidatedProjIDs = item.ConsolidatedProjIDs
                  ? item.ConsolidatedProjIDs.split(",")
                  : [];

                let ConsolidatedPeriodKeys =
                  item.ConsolidatedPeriodKeys &&
                  item.ConsolidatedPeriodKeys != 0
                    ? item.ConsolidatedPeriodKeys.split(",")
                    : [];

                let BillingStatementIDs =
                  item.BillingStatementIDs && item.BillingStatementIDs != null
                    ? item.BillingStatementIDs.split(",")
                    : [];

                // console.log("ConsolidatedProjIDs", ConsolidatedProjIDs)
                // console.log("ConsolidatedPeriodKeys", ConsolidatedPeriodKeys)
                // console.log("BillingStatementIDs", BillingStatementIDs)

                if (item.IsConsolidated) {
                  ConsolidatedProjIDs.forEach(function (itemCond, index) {
                    var ConsolidatedProjIDsId = ConsolidatedProjIDs[index];
                    var ConsolidatedPeriodKeysId =
                      ConsolidatedPeriodKeys[index];
                    var BillingStatementIDsId = BillingStatementIDs[index];

                    //  const matchingIndex = updatedB.findIndex(item =>
                    //   ConsolidatedProjIDs.includes(String(item.ProjectID)) &&
                    //   ConsolidatedPeriodKeys.includes(item.PeriodKey) &&
                    //   BillingStatementIDs.includes(String(item.BillingStatemrntId))
                    // );

                    const matchingIndex = updatedB.findIndex(
                      (item) =>
                        ConsolidatedProjIDsId == item.ProjectID &&
                        ConsolidatedPeriodKeysId == item.PeriodKey &&
                        BillingStatementIDsId == item.BillingStatemrntId
                    );

                    if (matchingIndex !== -1) {
                      if (item.StatusID == 4) {
                        const statusIds = updatedB[
                          matchingIndex
                        ].StatusId.split(",").map((id) => id.trim());

                        const statmentIdsCons = updatedB[
                          matchingIndex
                        ].statmentIds
                          .split(",")
                          .map((id) => id.trim());

                        const statusCounts = {
                          ...updatedB[matchingIndex].statusCounts,
                        };

                        var BillingStatementIDArray = item.BillingStatementIDs
                          ? item.BillingStatementIDs.split(",")
                          : null;

                        statusIds.forEach((id, index) => {
                          if (id === "3" && !BillingStatementIDArray) {
                            statusIds[index] = "4";
                            statusCounts["Invoice Started"]--;
                            statusCounts["Invoice Closed"]++;
                          }

                          if (
                            id === "3" &&
                            BillingStatementIDArray &&
                            BillingStatementIDArray.length > 0 &&
                            BillingStatementIDArray.includes(
                              statmentIdsCons[index]
                            )
                          ) {
                            statusIds[index] = "4";
                            statusCounts["Invoice Started"]--;
                            statusCounts["Invoice Closed"]++;
                          }
                        });

                        updatedB[matchingIndex]["StatusId"] =
                          statusIds.join(",");
                        updatedB[matchingIndex]["statusCounts"] = statusCounts;
                      }
                      updatedB[matchingIndex]["InvoiceId"] = item.InvoiceId;
                      updatedB[matchingIndex]["IsConsolidated"] =
                        item.IsConsolidated;

                      //console.log("Matching item index:", updatedB[matchingIndex]);
                    } else {
                      console.log("No matching item found.");
                    }
                  });
                }
              });
            }

            return updatedB;
          } else {
            return parsedResponse.data;
          }

          // setPeriods(parsedResponse.data);
          // setIsInvoiceSearch(true);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          showToast(v.message, "error");
        }
        return [];
      }
    } else {
      return [];
    }
  };

  const isAlreadyCovered = (periods, dateToCheck, ProjectId) => {
    for (let period of periods) {
      const dates = period.BillingDate.split(" - ");
      const startDate = dates[0];
      const endDate = dates[1];

      if (
        ProjectId == period.ProjectID &&
        (dateToCheck === startDate || dateToCheck === endDate)
      ) {
        return true;
      }
    }
    return false;
  };

  const dateToTimestamp = (dateStr) => {
    var dates = dateStr.split(" - ");
    var startDateStr = dates[0];
    var endDateStr = dates[1];
    var startDateStrparts = startDateStr.split("/");
    var endDateStrparts = endDateStr.split("/");
    var startDateTimestamp = startDateStrparts.join("");
    var endDateTimestamp = endDateStrparts.join("");
    return startDateTimestamp.toString() + endDateTimestamp.toString();
  };

  const generateBillingPeriods = async (
    startMonth,
    numberOfMonths,
    billPeriod,
    billingArray
  ) => {
    console.log(billingArray, "baiiajakaaak");
    const periodsArray = [];
    var periodsFilterArray = [];
    // const year = new Date().getFullYear();
    const now = new Date();
const currentYear = now.getFullYear();
const currentMonthNow = now.getMonth() + 1;

const year =
  startMonth > currentMonthNow ? currentYear - 1 : currentYear;

    for (let billPeriodData of billPeriod) {
      for (
        let month = startMonth;
        month < startMonth + numberOfMonths;
        month++
      ) {
        const currentMonth = ((month - 1) % 12) + 1; // Adjust month within 1-12 range
        // const adjustedYear = year + Math.floor((month - 1) / 12); // Adjust year if month exceeds December
        // const adjustedYear = year + Math.floor((month - 1) / 12); // Adjust year if month exceeds December
        // let adjustedYear = year;
         const adjustedYear = year + (currentMonth < startMonth ? 1 : 0);

        // If the month is less than the start month, adjust to the previous year
        // if (currentMonth >= startMonth) {
        //   adjustedYear = year;
        // }

        console.log(currentMonth, adjustedYear, "adjusteeeeeeeeeee"); // Check the output to debug

        console.log(adjustedYear, "jj", month, startMonth);

        const daysInMonth = new Date(adjustedYear, currentMonth, 0).getDate(); // Get number of days in the month
        let startDay = 1;

         while (startDay <= daysInMonth) {
          let endDay = startDay + billPeriodData.BillingPeriod - 1;

          if (endDay > daysInMonth) {
            endDay = daysInMonth; // Adjust end day to the last day of the month if it exceeds the number of days in the month
          }

          // Adjust for cases where the remaining days at the end of the month are less than the billing period
          if (endDay + billPeriodData.BillingPeriod > daysInMonth) {
            endDay = daysInMonth; // Set endDay to the last day of the month
          }


          // Format billing start and end dates
          const billingStart = moment(
            `${adjustedYear}-${currentMonth}-${startDay}`,
            "YYYY-MM-DD"
          ).format("MM/DD/YYYY");
          const billingEnd = moment(
            `${adjustedYear}-${currentMonth}-${endDay}`,
            "YYYY-MM-DD"
          ).format("MM/DD/YYYY");
          const billingStart1 = moment(
            `${adjustedYear}-${currentMonth}-${startDay}`,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");
          const billingEnd1 = moment(
            `${adjustedYear}-${currentMonth}-${endDay}`,
            "YYYY-MM-DD"
          ).format("DD/MM/YYYY");

          const billingStatrCheck = billingStart || billingStart1;
          const billingEndCheck = billingEnd || billingEnd1;

          // Check if the period is not a single day and does not overlap with the next period
          if (
            !(
              startDay === endDay &&
              isAlreadyCovered(
                periodsArray,
                billingStatrCheck,
                billPeriodData.ProjectId
              )
            ) &&
            !isAlreadyCovered(
              periodsArray,
              billingEndCheck,
              billPeriodData.ProjectId
            )
          ) {
            const period = `${billingStart} - ${billingEnd}`;
            const period1 = `${billingStart1} - ${billingEnd1}`;

            let periodData = {
              BillingStatemrntId: 0,
              statmentIds: "",
              ProjectID: billPeriodData.ProjectId,
              CustomerID: filter.userId,
              ProjectName: billPeriodData.Name,
              BillingStart: moment(billingStart, "MM/DD/YYYY").toISOString(),
              BillingEnd: moment(billingEnd, "MM/DD/YYYY").toISOString(),
              BillingDate: period,
              currentMonthNumberInvoice: currentMonth,
              BrokerCount: billPeriodData.BrokerCount,
              //BrokerCount: 0,
              Status: "",
              PeriodKey: dateToTimestamp(period),
              PeriodKeyMonth: dateToTimestamp(period1),
              StatusId: "",
              statusCounts: {
                StatementOpen: 0,
                StatementReady: 0,
                InvoiceStarted: 0,
                InvoiceClosed: 0,
              },
              IsConsolidated: false,
              currentMonth: currentMonthNumber === currentMonth ? true : false,
              currentYear: adjustedYear,
            };

            periodsArray.push(periodData);
          }
          startDay = endDay + 1;
// ✅ THIS IS THE FIX
        startDay = endDay + 1;
          // startDay += billPeriodData.BillingPeriod;

          // // Break the loop if startDay goes beyond the days in the month
          // if (startDay > daysInMonth) {
          //   break;
          // }
        }
      }
    }

    //OLD Code
    // if (
    //   invoicefilter.billingStartDate ||
    //   invoicefilter.billingEndDate ||
    //   invoicefilter.invoiceStatus
    // ) {
    //   billingArray &&
    //     billingArray.length > 0 &&
    //     billingArray.forEach((billing) => {
    //       let periodDataFilter = {
    //         BillingStatemrntId: billing.BillingStatemrntId,
    //         statmentIds: billing.statmentIds,
    //         ProjectID: billing.ProjectID,
    //         CustomerID: billing.CustomerID,
    //         ProjectName: billing.ProjectName,
    //         BillingStart: billing.BillingStart,
    //         BillingEnd: billing.BillingEnd,
    //         BillingDate:
    //           moment(billing.BillingStart).format("DD/MM/YYYY") +
    //           " - " +
    //           moment(billing.BillingEnd).format("DD/MM/YYYY"),
    //         BrokerCount: billing.BrokerCount,
    //         Status: billing.Status,
    //         PeriodKey: billing.PeriodKey,
    //         StatusId: billing.StatusId,
    //         statusCounts: billing.statusCounts,
    //         currentMonth: false,
    //         InvoiceId: billing.InvoiceId ? billing.InvoiceId : null,
    //         IsConsolidated: billing.IsConsolidated
    //           ? billing.IsConsolidated
    //           : false,
    //       };

    //       periodsFilterArray.push(periodDataFilter);
    //     });

    //   if (invoicefilter.invoiceStatus) {
    //     periodsFilterArray = periodsFilterArray.filter(
    //       (item) => item.StatusId == invoicefilter.invoiceStatus
    //     );
    //   }

    //   return periodsFilterArray;
    // } else {
    //   billingArray &&
    //     billingArray.length > 0 &&
    //     billingArray.forEach((billing) => {
    //       periodsArray.forEach((dateItem) => {
    //         if (
    //           dateItem.PeriodKey === billing.PeriodKey &&
    //           dateItem.ProjectID === billing.ProjectID &&
    //           billing.StatusId != ""
    //         ) {
    //           dateItem["BillingStatemrntId"] = billing.BillingStatemrntId;
    //           dateItem["statmentIds"] = billing.statmentIds;
    //           dateItem["ProjectID"] = billing.ProjectID;
    //           dateItem["CustomerID"] = billing.CustomerID;
    //           dateItem["ProjectName"] = billing.ProjectName;
    //           dateItem["BillingStart"] = billing.BillingStart;
    //           dateItem["BillingEnd"] = billing.BillingEnd;
    //           //dateItem["BillingDate"] = moment(billing.BillingStart).format("DD/MM/YYYY") +" - "+ moment(billing.BillingEnd).format("DD/MM/YYYY");
    //           dateItem["BrokerCount"] = billing.BrokerCount;
    //           dateItem["Status"] = billing.Status;
    //           dateItem["PeriodKey"] = billing.PeriodKey;
    //           dateItem["StatusId"] = billing.StatusId;
    //           dateItem["statusCounts"] = billing.statusCounts;
    //           dateItem["InvoiceId"] = billing.InvoiceId
    //             ? billing.InvoiceId
    //             : null;
    //           dateItem["IsConsolidated"] = billing.IsConsolidated
    //             ? billing.IsConsolidated
    //             : false;
    //           //dateItem["currentMonth"] = currentMonthNumber === currentMonth ? true : false;
    //         }
    //       });
    //     });

    //   return periodsArray;
    // }
    console.log(billingArray, "billingArraybillingArray", periodsArray);
    billingArray &&
      billingArray.length > 0 &&
      billingArray.forEach((billing) => {
        periodsArray.forEach((dateItem) => {
          if (
            (dateItem.PeriodKey === billing.PeriodKey || dateItem.PeriodKeyMonth === billing.PeriodKey) &&
            dateItem.ProjectID === billing.ProjectID &&
            billing.StatusId != ""
          ) {
            dateItem["BillingStatemrntId"] = billing.BillingStatemrntId;
            dateItem["statmentIds"] = billing.statmentIds;
            dateItem["ProjectID"] = billing.ProjectID;
            dateItem["CustomerID"] = billing.CustomerID;
            dateItem["ProjectName"] = billing.ProjectName;
            //dateItem["BillingStart"] = billing.BillingStart;
            //dateItem["BillingEnd"] = billing.BillingEnd;
            //dateItem["BillingDate"] = moment(billing.BillingStart).format("DD/MM/YYYY") +" - "+ moment(billing.BillingEnd).format("DD/MM/YYYY");
            //dateItem["BrokerCount"] = billing.BrokerCount;
            dateItem["Status"] = billing.Status;
            dateItem["PeriodKey"] = billing.PeriodKey;
            dateItem["StatusId"] = billing.StatusId;
            dateItem["statusCounts"] = billing.statusCounts;
            dateItem["InvoiceId"] = billing.InvoiceId
              ? billing.InvoiceId
              : null;
            dateItem["IsConsolidated"] = billing.IsConsolidated
              ? billing.IsConsolidated
              : false;
            //dateItem["currentMonth"] = currentMonthNumber === currentMonth ? true : false;
          }
        });
      });
    console.log(periodsArray, "36523786287982738");
    return periodsArray;
  };
  const generateBillingPeriods1 = async (
    invoiceFilter,
    billPeriod,
    billingArray
  ) => {
    const { billingStartDate, billingEndDate } = invoicefilter;
    console.log(invoicefilter, "invoicefilterinvoicefilter", billPeriod);
    const periodsArray = [];

    if (!billingStartDate || !billingEndDate) {
      console.error("Start date or end date is missing");
      return periodsArray;
    }

    const startMonth = moment(billingStartDate, "YYYY-MM-DD").month() + 1;
    const endMonth = moment(billingEndDate, "YYYY-MM-DD").month() + 1;
    const startYear = moment(billingStartDate, "YYYY-MM-DD").year();
    const endYear = moment(billingEndDate, "YYYY-MM-DD").year();
    console.log(startMonth, "monthhhhhhhh", endMonth, startYear, endYear);
    for (let year = startYear; year <= endYear; year++) {
      const loopStartMonth = year === startYear ? startMonth : 1;
      const loopEndMonth = year === endYear ? endMonth : 12;

      // Iterate through months for the given year range
      for (let month = loopStartMonth; month <= loopEndMonth; month++) {
        const daysInMonth = new Date(year, month, 0).getDate(); // Get the number of days in the current month
   let startDay = 1;
        // Iterate through billing periods for the given month
        for (let billPeriodData of billPeriod) {
       

          while (startDay <= daysInMonth) {
            // Calculate the endDay for the billing period, ensuring it doesn't exceed the days in the current month
            let endDay = startDay + billPeriodData.BillingPeriod - 1;

            if (endDay > daysInMonth) {
              endDay = daysInMonth; // Adjust end day to the last day of the month if it exceeds the number of days in the month
            }
            // Adjust for cases where the remaining days at the end of the month are less than the billing period
            if (endDay + billPeriodData.BillingPeriod > daysInMonth) {
              endDay = daysInMonth; // Set endDay to the last day of the month
            }

            // Create billing start and end dates in format (DD/MM/YYYY)
            const billingStart = moment(
              `${year}-${month}-${startDay}`,
              "YYYY-MM-DD"
            ).format("MM/DD/YYYY");
            const billingEnd = moment(
              `${year}-${month}-${endDay}`,
              "YYYY-MM-DD"
            ).format("MM/DD/YYYY");
            const billingStart1 = moment(
              `${year}-${month}-${startDay}`,
              "YYYY-MM-DD"
            ).format("DD/MM/YYYY");
            const billingEnd1 = moment(
              `${year}-${month}-${endDay}`,
              "YYYY-MM-DD"
            ).format("DD/MM/YYYY");

            // Log to check if the periods are calculated correctly
            console.log(
              "Billing Start:",
              billingStart,
              "Billing End:",
              billingEnd
            );
            console.log(
              startDay,
              billPeriodData.BillingPeriod,
              "ensssssssss",
              daysInMonth
            );

        const billingStatrCheck = billingStart || billingStart1
        const billingEndCheck = billingEnd || billingEnd1

            // Ensure the billing period is not already covered (existing condition)
            if (
              !isAlreadyCovered(
                periodsArray,
                billingStatrCheck,
                billPeriodData.ProjectId
              ) &&
              !isAlreadyCovered(
                periodsArray,
                billingEndCheck,
                billPeriodData.ProjectId
              )
            ) {
              const periodData = {
                BillingStatemrntId: 0,
                statmentIds: "",
                ProjectID: billPeriodData.ProjectId,
                CustomerID: invoiceFilter.userId || "",
                ProjectName: billPeriodData.Name,
                BillingStart: moment(billingStart, "MM/DD/YYYY").toISOString(),
                BillingEnd: moment(billingEnd, "MM/DD/YYYY").toISOString(),
                BillingDate: `${billingStart} - ${billingEnd}`,
                BrokerCount: billPeriodData.BrokerCount || 0,
                Status: "",
                PeriodKey: dateToTimestamp(`${billingStart} - ${billingEnd}`),
                PeriodKeyMonth: dateToTimestamp(`${billingStart1} - ${billingEnd1}`),
                StatusId: "",
                statusCounts: {
                  StatementOpen: 0,
                  StatementReady: 0,
                  InvoiceStarted: 0,
                  InvoiceClosed: 0,
                },
                IsConsolidated: false,
              };
              periodsArray.push(periodData);
            }
            startDay = endDay + 1;
if (startDay > daysInMonth) {
              break; // Exit the while loop and move to the next period
            }
          }
        }
      }
    }

    billingArray &&
      billingArray.length > 0 &&
      billingArray.forEach((billing) => {
        periodsArray.forEach((dateItem) => {
          console.log(billing, "billingbillingbilling", dateItem);
          if (
            (dateItem.PeriodKey == billing.PeriodKey || dateItem.PeriodKeyMonth == billing.PeriodKey) &&
            dateItem.ProjectID == billing.ProjectID &&
            billing.StatusId != ""
          ) {
            console.log(billing, "billingbillingbilling", dateItem);
            dateItem["BillingStatemrntId"] = billing.BillingStatemrntId;
            dateItem["statmentIds"] = billing.statmentIds;
            dateItem["ProjectID"] = billing.ProjectID;
            dateItem["CustomerID"] = billing.CustomerID;
            dateItem["ProjectName"] = billing.ProjectName;
            //dateItem["BillingStart"] = billing.BillingStart;
            //dateItem["BillingEnd"] = billing.BillingEnd;
            //dateItem["BillingDate"] = moment(billing.BillingStart).format("DD/MM/YYYY") +" - "+ moment(billing.BillingEnd).format("DD/MM/YYYY");
            //dateItem["BrokerCount"] = billing.BrokerCount;
            dateItem["Status"] = billing.Status;
            dateItem["PeriodKey"] = billing.PeriodKey;
            dateItem["StatusId"] = billing.StatusId;
            dateItem["statusCounts"] = billing.statusCounts;
            dateItem["InvoiceId"] = billing.InvoiceId
              ? billing.InvoiceId
              : null;
            dateItem["IsConsolidated"] = billing.IsConsolidated
              ? billing.IsConsolidated
              : false;
            //dateItem["currentMonth"] = currentMonthNumber === currentMonth ? true : false;
          }
        });
      });
    console.log(periodsArray, "periodsArrayperiodsArray");
    return periodsArray;
  };

  const getFutureMonth = (currentMonth, numberOfMonths) => {
    let MonthStart = currentMonth - 3; // Change from -4 to -3
    if (MonthStart < 1) {
      MonthStart += 12; // Wrap around to the previous year
    }
    return MonthStart;
  };

  const handleSearchDeleteOnChange = (value) => {
    var arr = selectedProject.filter((item) => item.ProjectId != value);
    if (arr.length > 0) {
      const projectIds = arr.map((item) => item.ProjectId);
      console.log(projectIds,'aprojectIdsrrrrrrrrrr')
      setFilter((prevState) => ({ ...prevState, projectId: projectIds }));
      dispatch({
        type: types.INVOICE_LIST_SELECT,
        payload: {
          ...filter,
          projectId: projectIds, // Assuming 'value' is the new project ID you want to set
          filter: "",
        },
      });
    } else {
      setFilter((prevState) => ({ ...prevState, projectId: [] }));
      dispatch({
        type: types.INVOICE_LIST_SELECT,
        payload: {
          ...filter,
          projectId: [], // Assuming 'value' is the new project ID you want to set
          filter: "",
        },
      });
    }
    dispatch({
      type: SORT_PARAMS,
      payload: { order: "", orderBy: "" },
    });
    setSelectedProjects(arr);

    const filteredPeriod = consoldiateCheckBoxFilter.periods.filter((item) => {
      return item.ProjectID != value;
    });

    const billingIdsMatched = filteredPeriod
      .filter((item) => item.BillingStatemrntId > 0)
      .map((item) => item.BillingStatemrntId);

    // Find matched values
    const matchedValues = billingIdsMatched.filter((value) =>
      consoldiateCheckBoxFilter.invoiceSingleCheckBox.includes(value)
    );

    setInvoiceCheckBox(matchedValues);

    dispatch({
      type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
      payload: {
        ...consoldiateCheckBoxFilter,
        periods: filteredPeriod ? filteredPeriod : [],
        invoiceSingleCheckBox: matchedValues,
      },
    });

    const matchedArray = filteredPeriod
      .filter((item) => {
        if (item.StatusId) {
          var StatusIdArray = item.StatusId.split(",");
          let trimmedStatusArr = StatusIdArray.map((str) => str.trim());
          let containsOne = trimmedStatusArr.includes("2");
          //let containsTwo = trimmedStatusArr.includes('2');
          //return containsOne || containsTwo;
          return containsOne;
        }
        return false;
      })
      .map((item) => item.BillingStatemrntId);

    if (matchedArray.length != matchedValues) {
      setInvoiceCheckBoxAll("");
    }

    setInvoicefilter(invoiceFilterInitial);
    setApplyFilterFlag(false);
    dispatch({
      type: SORT_PARAMS,
      payload: { order: "", orderBy: "" },
    });
    // dispatch({
    //   type: types.INVOICE_LIST_SELECT,
    //   payload: {
    //     ...filter,
    //     filter: invoiceFilterInitial,
    //   },
    // });
  };

  const filterOpenFun = () => {
    setOpenFilter(!openFilter);
    if (openFilter) {
      setApplyFilterFlag(false);
    }
  };

  const consolidateInvoiceFun = async () => {
    setConsoidatedComponent(true);
    setLoading(true);
    if (invoiceCheckBox && invoiceCheckBox.length > 0) {
      const matchedData = periods?.filter((item) =>
        invoiceCheckBox.includes(item.BillingStatemrntId)
      );

      if (matchedData && matchedData.length > 0) {
        for (let data of matchedData) {
          const dataInvoiceStatement = await getInvoiceRowByID({
            projectId: data.ProjectID.toString(),
            periodKey: data.PeriodKey,
          });
          data.brokerDetail = dataInvoiceStatement;
        }
      }

      console.log(matchedData, "matchhhhhhhhhh");
      dispatch({
        type: types.CONSOLIDATE_INVOICE_LIST_SELECT,
        payload: {
          ...consoldiateCheckBoxFilter,
          matchedData: matchedData,
          userList: userList,
          periods: periods,
          billingPeriodsStatementIds: [],
        },
      });

      navigate(CONSOLIDATED_INVOICE_LIST, {
        state: { matchedData: matchedData, userList: userList },
      });
    }
    setLoading(false);
  };

  const filterClose = () => {
    setOpenFilter(false);
  };

  const submitFilter = () => {
    setOpenFilter(false);
    setApplyFilterFlag(true);
    // if (applyFilterFlag) {
    //   getInvoiceFilterList();
    // }
    dispatch({
      type: SORT_PARAMS,
      payload: { order: "", orderBy: "" },
    });
    dispatch({
      type: types.INVOICE_LIST_SELECT,
      payload: {
        ...filter,
        filter: "",
      },
    });
  };

  const clearBillingFilterFunc = () => {
    setInvoicefilter(invoiceFilterInitial);
    setApplyFilterFlag(false);
    dispatch({
      type: SORT_PARAMS,
      payload: { order: "", orderBy: "" },
    });
    dispatch({
      type: types.INVOICE_LIST_SELECT,
      payload: {
        ...filter,
        filter: invoiceFilterInitial,
      },
    });
  };

  const handleCloseInvoice = () => {
    setConsolidateInvoiceModel(!consolidateInvoiceModel);
    dispatch(getAllCustomersList());
    getProjectList(reduxFilter.userId, reduxFilter);
    getInvoiceFilterList();
  };

  const handleModelPopupInvoiceReload = (rowValueIndex) => {
    let rowPeriodValue = sortedLocationList[rowValueIndex];
    if (rowPeriodValue) {
      handleDebouncedClick(rowPeriodValue);
      console.log("rowValue from invoice", rowPeriodValue);
    }
  };

  const createCloseBillingPeriod = () => {
    setCreateBillingPeriodModel(false);
    dispatch(getAllCustomersList());
    getProjectList(reduxFilter.userId, reduxFilter);
    getInvoiceFilterList();
  };

  // const createCloseInvoiceOld = async (val, brokerValue) => {
  //   setConsolidateInvoiceModel(!consolidateInvoiceModel);
  //   if (val) {
  //     const matchedCustomerRow = userList.find(
  //       (item) => item.UserId === selectedInvoicePeriod.CustomerID
  //     );

  //     var brokerDayRate = 0;

  //     let dataProjectPayload = {
  //       projectId: selectedInvoicePeriod.ProjectID,
  //     };
  //     const configProjectConfig = {
  //       method: "GET",
  //       headers: authHeader(),
  //       url: GET_PROJECT_DETAILS_BY_ID_URL,
  //       params: {
  //         webString: enCryptFun(JSON.stringify(dataProjectPayload)),
  //       },
  //     };
  //     try {
  //       const response = await API(configProjectConfig);
  //       let decryptedResponse = deCryptFun(response.data);
  //       const parsedResponse = JSON.parse(decryptedResponse);
  //       if (parsedResponse.status === "Success") {
  //         //Project Broker
  //         if (parsedResponse.BrokerDetails) {
  //           let BrokerDetails = parsedResponse.BrokerDetails;
  //           var activeBrokers = BrokerDetails.find(function (broker) {
  //             return broker.Active === true;
  //           });
  //           if (activeBrokers && activeBrokers.UserID) {
  //             brokerDayRate = activeBrokers.DayRate;
  //           }
  //         }
  //       }
  //     } catch (error) {}

  //     for (let data of selectedPeriod) {
  //       if (brokerValue.includes(data.BrokerID)) {
  //         var totalPerDiem = 0;
  //         var expenses = 0;
  //         var mileage = 0;
  //         var charges = 0;

  //         if (data && data.PerDiem) {
  //           totalPerDiem = data.PerDiem;
  //         }

  //         if ((data && data.Lodging) || data.Copies || data.Misc) {
  //           if (data.Lodging) {
  //             expenses = expenses + data.Lodging;
  //           }

  //           if (data.Copies) {
  //             expenses = expenses + data.Copies;
  //           }

  //           if (data.Misc) {
  //             expenses = expenses + data.Misc;
  //           }
  //         }

  //         if (data && data.Miles && data.MileageRate) {
  //           mileage = data.Miles * data.MileageRate;
  //         }

  //         if (data.Hours && brokerDayRate) {
  //           charges = (data.Hours / 8) * brokerDayRate;
  //         }

  //         const totalValue =
  //           parseFloat(totalPerDiem) +
  //           parseFloat(expenses) +
  //           parseFloat(mileage) +
  //           parseFloat(charges);

  //         let invoiceCreateObj = {
  //           invoiceId: 0,
  //           customerId:
  //             selectedInvoicePeriod.CustomerID &&
  //             selectedInvoicePeriod.CustomerID,
  //           periodKey: data.PeriodKey,
  //           projectId: data.ProjID,
  //           statusId: 3,
  //           billingStart: data.BillingStart,
  //           billingEnd: data.BillingEnd,
  //           invoiceDate: new Date().toISOString(),
  //           createDate: new Date().toISOString(),
  //           billToStreet1: matchedCustomerRow.BAStreet1,
  //           billToStreet2: matchedCustomerRow.BAStreet2,
  //           billToCity: matchedCustomerRow.BACity,
  //           billToState: matchedCustomerRow.BAState,
  //           billToZip: matchedCustomerRow.BAZip,
  //           brokerCount: selectedInvoicePeriod.BrokerCount,
  //           brokerHours: data.Hours,
  //           dayRate: brokerDayRate,
  //           perDiem: data.PerDiem,
  //           lodging: data.Lodging,
  //           miles: data.Miles,
  //           misc: data.Misc,
  //           copies: data.Copies,
  //           mileageRate: data.MileageRate,
  //           invoiceTotal: totalValue,
  //           headerIds: data.BillingStatementID.toString(),
  //           isConsolidated: false,
  //         };

  //         const config = {
  //           method: "POST",
  //           url: UPSERT_INVOICE_STATEMENT_URL,
  //           headers: authHeader(),
  //           data: {
  //             webString: enCryptFun(JSON.stringify(invoiceCreateObj)),
  //           },
  //         };

  //         try {
  //           const response = await API(config);
  //           let decryptedResponse = deCryptFun(response.data);
  //           const parsedResponse = JSON.parse(decryptedResponse);

  //           if (parsedResponse.billingStatementId) {
  //             navigate(`/invoice-form/${parsedResponse.billingStatementId}`);
  //           }
  //         } catch (error) {
  //           if (error.response) {
  //             let { data } = error.response;
  //             let p = deCryptFun(data);
  //             let v = JSON.parse(p);
  //             showToast(v.message,'error')
  //           }
  //           return null;
  //         }
  //       }
  //     }

  //     showToast("Invoice Statement Created Successfully", "success");
  //   }
  //   setSelectedPeriod([]);
  //   setSelectedInvoicePeriod([]);
  // };
  console.log(
    dayjs().utc().format(),
    "const utcDate = dayjs().utc().format();",
    dayjs().tz("America/New_York").format()
  );

  const createCloseInvoice = async (val, brokerValue) => {
    if (val) {
      const matchedCustomerRow = userList.find(
        (item) => item.UserId === selectedInvoicePeriod.CustomerID
      );

      var billingDayRate = 0;
      var billingMillegeRate = 0;
      var BrokerCount = 0;

      let dataProjectPayload = {
        projectId: selectedInvoicePeriod.ProjectID,
      };
      const configProjectConfig = {
        method: "GET",
        headers: authHeader(),
        url: GET_PROJECT_DETAILS_BY_ID_URL,
        params: {
          webString: enCryptFun(JSON.stringify(dataProjectPayload)),
        },
      };
      try {
        const response = await API(configProjectConfig);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          console.log("parsedResponse", parsedResponse);
          if (
            parsedResponse.ProjectDetails &&
            parsedResponse.ProjectDetails[0]
          ) {
            let ProjectDetails = parsedResponse.ProjectDetails[0];
            billingDayRate = ProjectDetails.BillingDayRate;
            billingMillegeRate = ProjectDetails.MileageRate;
            BrokerCount = ProjectDetails.BrokerDetails.length;
          }
        }
      } catch (error) {}

      const sum = {
        Hours: 0,
        DayRate: 0,
        PerDiem: 0,
        Lodging: 0,
        Copies: 0,
        Misc: 0,
        Miles: 0,
        MileageRate: 0,
        Total: 0,
      };
      var headerIds = [];
      var projectIds = "";
      var userIds = [];
      var periodKeys = [];

      for (let data of selectedPeriod) {
        if (brokerValue.includes(data.BrokerID)) {
          var totalPerDiem = 0;
          var expenses = 0;
          var mileage = 0;
          var charges = 0;

          if (data && data.PerDiem) {
            totalPerDiem = data.PerDiem;
          }

          if ((data && data.Lodging) || data.Copies || data.Misc) {
            if (data.Lodging) {
              expenses = expenses + data.Lodging;
            }

            if (data.Copies) {
              expenses = expenses + data.Copies;
            }

            if (data.Misc) {
              expenses = expenses + data.Misc;
            }
          }

          if (data && data.Miles && billingMillegeRate) {
            mileage = data.Miles * billingMillegeRate;
          }

          if (data.Hours && billingDayRate) {
            charges = (data.Hours / 8) * billingDayRate;
          }

          const totalValue =
            parseFloat(totalPerDiem) +
            parseFloat(expenses) +
            parseFloat(mileage) +
            parseFloat(charges);

          sum.Hours += data.Hours ? data.Hours : 0;
          sum.DayRate = billingDayRate;
          sum.PerDiem += data.PerDiem ? data.PerDiem : 0;
          sum.Lodging += data.Lodging ? data.Lodging : 0;
          sum.Copies += data.Copies ? data.Copies : 0;
          sum.Misc += data.Misc ? data.Misc : 0;
          sum.Miles += data.Miles ? data.Miles : 0;
          sum.MileageRate = billingMillegeRate;
          sum.Total += totalValue ? totalValue : 0;

          var objheader = {
            ID: 0,
            projectId: data.ProjID,
            periodKey: data.PeriodKey,
            billingStart: data.BillingStart,
            billingEnd: data.BillingEnd,
            statusID: 3,
            brokerCount: BrokerCount,
            brokerHours: data.Hours,
            dayRate: billingDayRate,
            perDiem: data.PerDiem,
            miles: data.Miles,
            mileageRate: billingMillegeRate,
            total: totalValue,
            lodging: data.Lodging,
            copies: data.Copies,
            misc: data.Misc,
          };

          // headerArray.push(objheader);
          headerIds.push(data.BillingStatementID);
          // projectIds.push(data.ProjID);
          projectIds = data.ProjID;
          userIds.push(getLogUserId());
          periodKeys.push(data.PeriodKey);
        }
      }

      let invoiceCreateObj = {
        invoiceId: 0,
        customerId:
          selectedInvoicePeriod.CustomerID && selectedInvoicePeriod.CustomerID,
        periodKey: periodKeys.join(","),
        projectId: projectIds,
        userId: userIds.join(","),
        statusId: 3,
        billingStart: selectedInvoicePeriod?.BillingStart,
        billingEnd: selectedInvoicePeriod?.BillingEnd,
        invoiceDate: dayjs().tz("America/New_York").format(),
        createDate: dayjs().tz("America/New_York").format(),
        billToStreet1: matchedCustomerRow.BAStreet1 ? matchedCustomerRow.BAStreet1 : "",
        billToStreet2: matchedCustomerRow.BAStreet2 ? matchedCustomerRow.BAStreet2 : "",
        billToCity: matchedCustomerRow.BACity,
        billToState: matchedCustomerRow.BAState ? matchedCustomerRow.BAState : "",
        billToZip: matchedCustomerRow.BAZip,
        brokerCount: BrokerCount,
        brokerHours: sum.Hours,
        dayRate: sum.DayRate,
        perDiem: sum.PerDiem,
        lodging: sum.Lodging,
        miles: sum.Miles,
        misc: sum.Misc,
        copies: sum.Copies,
        mileageRate: sum.MileageRate,
        invoiceTotal: sum.Total,
        headerIds: headerIds.join(","),
        isConsolidated: false,
      };

      const config = {
        method: "POST",
        url: UPSERT_INVOICE_STATEMENT_URL,
        headers: authHeader(),
        data: {
          webString: enCryptFun(JSON.stringify(invoiceCreateObj)),
        },
      };

      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);

        if (parsedResponse.billingStatementId) {
          navigate(`/invoice-form/${parsedResponse.billingStatementId}`);
          setConsolidateInvoiceModel(!consolidateInvoiceModel);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          showToast(v.message, "error");
          handleInvoiceSingleRoWCreate(periodValues);
        }
        return null;
      }

      showToast("Invoice Statement Created Successfully", "success");
    }
    setSelectedPeriod([]);
    setSelectedInvoicePeriod([]);
  };

  const createBillingInvoice = async (val) => {
    setLoading(true);

    if (val) {
      // console.log("setCreateBillingPeriodModel", val)
      console.log(val, "valaaaaaaaaaaaaa");
      const matchedCustomerRow = userList.find(
        (item) => item.UserId === val.CustomerID
      );

      var billingDayRate = 0;
      var billingMillegeRate = 0;
      var BrokerCount = 0;

      let dataProjectPayload = {
        projectId: val.ProjectID,
      };

      const configProjectConfig = {
        method: "GET",
        headers: authHeader(),
        url: GET_PROJECT_DETAILS_BY_ID_URL,
        params: {
          webString: enCryptFun(JSON.stringify(dataProjectPayload)),
        },
      };
      try {
        const response = await API(configProjectConfig);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);
        if (parsedResponse.status === "Success") {
          console.log("parsedResponse", parsedResponse);
          if (
            parsedResponse.ProjectDetails &&
            parsedResponse.ProjectDetails[0]
          ) {
            let ProjectDetails = parsedResponse.ProjectDetails[0];
            billingDayRate = ProjectDetails.BillingDayRate;
            billingMillegeRate = ProjectDetails.MileageRate;
            BrokerCount = ProjectDetails.BrokerDetails.length;
          }
        }
      } catch (error) {}

      console.log(matchedCustomerRow, "matchedCustomerRowmatchedCustomerRow");
      console.log(
        billingDayRate,
        "billingMillegeRatebillingMillegeRatebillingMillegeRate",
        billingMillegeRate
      );

      let invoiceCreateObj = {
        invoiceId: 0,
        customerId: val.CustomerID,
        periodKey: val.PeriodKey,
        projectId: val.ProjectID,
        userId: getLogUserId(),
        statusId: 3,
        billingStart: val.BillingStart,
        billingEnd: val.BillingEnd,
        invoiceDate: dayjs().tz("America/New_York").format(),
        createDate: dayjs().tz("America/New_York").format(),
        billToStreet1: matchedCustomerRow.BAStreet1 ? matchedCustomerRow.BAStreet1 : "",
        billToStreet2: matchedCustomerRow.BAStreet2 ? matchedCustomerRow.BAStreet2 : "",
        billToCity: matchedCustomerRow.BACity,
        billToState: matchedCustomerRow.BAState ? matchedCustomerRow.BAState : '',
        billToZip: matchedCustomerRow.BAZip,
        brokerCount: val.BrokerCount,
        brokerHours: 0,
        dayRate: billingDayRate,
        perDiem: 0,
        lodging: 0,
        miles: 0,
        misc: 0,
        copies: 0,
        mileageRate: billingMillegeRate,
        invoiceTotal: 0,
        headerIds: null,
        isConsolidated: false,
      };

      const config = {
        method: "POST",
        url: UPSERT_INVOICE_STATEMENT_URL,
        headers: authHeader(),
        data: {
          webString: enCryptFun(JSON.stringify(invoiceCreateObj)),
        },
      };

      try {
        const response = await API(config);
        let decryptedResponse = deCryptFun(response.data);
        const parsedResponse = JSON.parse(decryptedResponse);

        if (parsedResponse.billingStatementId) {
          showToast("Invoice Statement Created Successfully", "success");
          navigate(`/invoice-form/${parsedResponse.billingStatementId}`);
        }
      } catch (error) {
        if (error.response) {
          let { data } = error.response;
          let p = deCryptFun(data);
          let v = JSON.parse(p);
          showToast(v.message, "error");
        }
        return null; // Return null on error
      }
    }
    setLoading(false);
    setCreateBillingPeriodModel(false);
    setSelectedPeriod([]);
    setSelectedInvoicePeriod([]);
  };

  const handleSearchOnChange = (event, newValue) => {
    if (event.target.type != "text" && !loading) {
      const duplicateArray = findDuplicateProjectId(newValue);
      if (duplicateArray && duplicateArray.length > 0) {
        const updatedNewArray = newValue.filter(
          (obj) => obj.ProjectId !== duplicateArray[0]
        );
        newValue = updatedNewArray;
      }

      const uniqueSelectedProjects = newValue.filter(
        (item, index, self) =>
          index === self.findIndex((t) => t.ProjectId === item.ProjectId)
      );

      const projectIds = uniqueSelectedProjects.map((item) => item.ProjectId);
      setFilter((prevState) => ({ ...prevState, projectId: projectIds }));
      dispatch({
        type: types.INVOICE_LIST_SELECT,
        payload: {
          ...filter,
          projectId: projectIds, // Assuming 'value' is the new project ID you want to set
          filter: "",
        },
      });
      dispatch({
        type: SORT_PARAMS,
        payload: { order: "", orderBy: "" },
      });
      setSelectedProjects(uniqueSelectedProjects);
    }
  };

  const findDuplicateProjectId = (array) => {
    let seen = new Set();
    let duplicates = new Set();

    array.forEach((obj) => {
      if (seen.has(obj.ProjectId)) {
        duplicates.add(obj.ProjectId);
      } else {
        seen.add(obj.ProjectId);
      }
    });

    return Array.from(duplicates);
  };

  const handleInvoiceBrokerCount = async (period, Invoiceobj, status) => {
    let data = {
      projectId: period.ProjectID.toString(),
      periodKey: period.PeriodKey,
    };
    const dataInvoiceStatement = await getInvoiceRowByID(data);

    let viewBrokerObj = {
      period: period,
      Invoiceobj: Invoiceobj,
      dataInvoiceStatement: dataInvoiceStatement,
      status: status,
    };

    console.log(viewBrokerObj, "viewBrokerObj");

    setViewInvoiceBrokerModel(true);
    setViewInvoiceBrokerDetail(viewBrokerObj);
  };

  const handleInvoiceSingleRoWCreate = async (
    value,
    isAdminGeneratedHaveEntry
  ) => {
    console.log(
      value,
      isAdminGeneratedHaveEntry,
      "value.StatusIdvalue.StatusIdvalue.StatusId"
    );
    if (value.StatusId) {
      var StatusIdArray = value.StatusId.split(",");
      let trimmedStatusArr = StatusIdArray.map((str) => str.trim());
      let containsOne = trimmedStatusArr.includes("1");
      let containsTwo = trimmedStatusArr.includes("2");
      let containsThree = trimmedStatusArr.includes("3");
      let containsFour = trimmedStatusArr.includes("4");
      if (containsOne || containsTwo || containsThree || containsFour) {
        // if (containsOne) {
        let data = {
          projectId: value.ProjectID.toString(),
          periodKey: value.PeriodKey,
        };
        const dataInvoiceStatement = await getInvoiceRowByID(data);
        const matchedData = periods.filter(
          (item) => item.BillingStatemrntId === value.BillingStatemrntId
        );
        setSelectedPeriod(dataInvoiceStatement);
        setSelectedInvoicePeriod(
          matchedData && matchedData.length > 0 ? matchedData[0] : []
        );
        setConsolidateInvoiceModel(true);
      } else {
        if (value.InvoiceId && !value.IsConsolidated) {
          navigate(`/invoice-form/${value.InvoiceId}`);
          if (containsFour) {
            showToast(
              "This invoice has been closed and can no longer be edited.",
              "reopenInvoice"
            );
          }
        } else if (value.InvoiceId && value.IsConsolidated) {
          navigate(`/consolidated-invoice-form/${value.InvoiceId}`);
          if (containsFour) {
            showToast(
              "This invoice has been closed and can no longer be edited.",
              "reopenInvoice"
            );
          }
        } else {
          let data = {
            projectId: value.ProjectID.toString(),
            periodKey: value.PeriodKey,
          };
          const dataInvoiceStatement = await getInvoiceRowByID(data);

          if (
            dataInvoiceStatement &&
            dataInvoiceStatement[0] &&
            dataInvoiceStatement[0].InvoiceID
          ) {
            navigate(`/invoice-form/${dataInvoiceStatement[0].InvoiceID}`);
          }
        }
      }
    } else if (isAdminGeneratedHaveEntry) {
      let data = {
        projectId: value.ProjectID.toString(),
        periodKey: value.PeriodKey,
      };
      const dataInvoiceStatement = await getInvoiceRowByID(data);
      const matchedData = periods.filter(
        (item) => item.BillingStatemrntId === value.BillingStatemrntId
      );
      setSelectedPeriod(dataInvoiceStatement);
      setSelectedInvoicePeriod(
        matchedData && matchedData.length > 0 ? matchedData[0] : []
      );
      setConsolidateInvoiceModel(true);
    } else {
      setSelectedInvoicePeriod(value);
      setCreateBillingPeriodModel(true);
    }
  };

  const getInvoiceRowByID = async (dataValue) => {
    getAdminInvoiceStatementById(dataValue);
    const config = {
      method: "GET",
      url: GET_ALL_INVOICE_STATEMENT_BY_ID_URL,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(dataValue)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      if (
        parsedResponse &&
        parsedResponse.billingStatementDetails &&
        parsedResponse.billingStatementDetails.length > 0
      ) {
        var billingStatementDetailArray =
          parsedResponse.billingStatementDetails;

        // for (let detail of billingStatementDetailArray) {
        //   var totalPerDiem = 0;
        //   var expenses = 0;
        //   var mileage = 0;
        //   var charges = 0;

        //   if (detail.PerDiem) {
        //     totalPerDiem = detail.PerDiem;
        //   }

        //   if (detail.Lodging || detail.Copies || detail.Misc) {
        //     if (detail.Lodging) {
        //       expenses = expenses + detail.Lodging;
        //     }
        //     if (detail.Copies) {
        //       expenses = expenses + detail.Copies;
        //     }
        //     if (detail.Misc) {
        //       expenses = expenses + detail.Misc;
        //     }
        //   }

        //   if (detail.Miles && detail.MileageRate) {
        //     mileage = detail.Miles * detail.MileageRate;
        //   }

        //   if (detail.Hours && detail.ProjectDayRate) {
        //     charges = (detail.Hours / 8) * detail.ProjectDayRate;
        //   }

        //   const totalValue =
        //     parseFloat(totalPerDiem) +
        //     parseFloat(expenses) +
        //     parseFloat(mileage) +
        //     parseFloat(charges);
        //   detail["Total"] = totalValue;
        // }

        return billingStatementDetailArray;
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        // showToast(v.message, "error");
      }
      return null; // Return null on error
    }
  };

  const getAdminInvoiceStatementById = async (dataValue) => {
    const config = {
      method: "GET",
      url: GET_ADMIN_INVOICE_STATEMENT_BY_ID,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(dataValue)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      console.log(parsedResponse, "parsedddddddddddddd");
      if (parsedResponse.status === "Success") {
        setAdminDirectCreation(parsedResponse.ConsolidatedDetails);
        setAdminSingleInvoiceDirectCreation(
          parsedResponse.billingStatementDetails
        );
      } else {
        setAdminDirectCreation([]);
        setAdminSingleInvoiceDirectCreation([]);
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        // showToast(v.message, "error");
      }
      setAdminDirectCreation([]);
      setAdminSingleInvoiceDirectCreation([]);
      return null; // Return null on error
    }
  };

  const getAdminInvoiceStatementByIdByInvoiceList = async (dataValue) => {
    const config = {
      method: "GET",
      url: GET_ADMIN_INVOICE_STATEMENT_BY_ID,
      headers: authHeader(),
      params: {
        webString: enCryptFun(JSON.stringify(dataValue)),
      },
    };

    try {
      const response = await API(config);
      let decryptedResponse = deCryptFun(response.data);
      const parsedResponse = JSON.parse(decryptedResponse);
      console.log(parsedResponse, "parsedddddddddddddd");
      if (parsedResponse.status === "Success") {
        return parsedResponse;
        // setAdminDirectCreation(parsedResponse.ConsolidatedDetails);
        // setAdminSingleInvoiceDirectCreation(parsedResponse.billingStatementDetails);
      } else {
        return null;
      }
    } catch (error) {
      if (error.response) {
        let { data } = error.response;
        let p = deCryptFun(data);
        let v = JSON.parse(p);
        // showToast(v.message, "error");
      }
      return null; // Return null on error
    }
  };

  const [anchorEl1, setAnchorEl1] = React.useState(null);
  const [anchorEl2, setAnchorEl2] = React.useState(null);
  const [anchorEl3, setAnchorEl3] = React.useState(null);
  const [anchorEl4, setAnchorEl4] = React.useState(null);
  const [anchorEl5, setAnchorEl5] = React.useState(null);

  const opens1 = Boolean(anchorEl1);
  const opens2 = Boolean(anchorEl2);
  const opens3 = Boolean(anchorEl3);
  const opens4 = Boolean(anchorEl4);
  const opens5 = Boolean(anchorEl5);

  const handlePopoverOpen1 = (event) => {
    setAnchorEl1(event.currentTarget);
  };

  const handlePopoverClose1 = () => {
    setAnchorEl1(null);
  };

  const handlePopoverOpen2 = (event) => {
    setAnchorEl2(event.currentTarget);
  };

  const handlePopoverClose2 = () => {
    setAnchorEl2(null);
  };

  const handlePopoverOpen3 = (event) => {
    setAnchorEl3(event.currentTarget);
  };

  const handlePopoverClose3 = () => {
    setAnchorEl3(null);
  };

  const handlePopoverOpen4 = (event) => {
    setAnchorEl4(event.currentTarget);
  };

  const handlePopoverClose4 = () => {
    setAnchorEl4(null);
  };

  const handlePopoverOpen5 = (event) => {
    setAnchorEl5(event.currentTarget);
  };

  const handlePopoverClose5 = () => {
    setAnchorEl5(null);
  };

  useEffect(() => {
    if (!handleInvoiceChangeInvoiceStatus) {
      const loadData = async () => {
        setBillingStatementLoading(true); // Start loading
        try {
          await getProjectList(reduxFilter.userId, reduxFilter);
          // Nested async function to handle fetching of customers
          const fetchData = async () => {
            try {
              if (reduxFilter?.userId && !filter?.userId) {
                await dispatch(getAllCustomersList());
                setFilter((prevFilter) => ({ ...prevFilter, ...reduxFilter }));
              } else {
                await dispatch(getAllCustomersList());
              }
            } catch (error) {
              console.error(
                "An error occurred while fetching customer data:",
                error
              );
            }
          };

          await fetchData(); // Call fetchData after getDashboardFilterBroker completes
        } catch (error) {
          console.error(
            "An error occurred while fetching dashboard filter:",
            error
          );
        } finally {
          setBillingStatementLoading(false); // End loading
        }
      };

      loadData();

      if (
        reduxFilter &&
        reduxFilter.filter &&
        (reduxFilter.filter.billingStartDate ||
          reduxFilter.filter.billingEndDate ||
          reduxFilter.filter.billingStartDateDatepicker ||
          reduxFilter.filter.billingEndDateDatepicker ||
          reduxFilter.filter.invoiceStatus) &&
        !isEqual(reduxFilter.filter, invoicefilter)
      ) {
        setInvoicefilter(reduxFilter.filter);
        setApplyFilterFlag(true);
        console.log(reduxFilter.filter);
      }
    }
  }, [reduxFilter, dispatch]);
  // Adjust dependencies as needed

  // useEffect(() => {
  //   // Trigger getProjectList only when assignedProject has been set
  //   if (reduxFilter?.userId) {
  //     getProjectList(reduxFilter.userId);
  //   }
  // }, [reduxFilter.userId]);

  useEffect(() => {
    getInvoiceFilterList();
  }, [filter.userId, filter.projectId]);

  useEffect(() => {
    console.log(" periods ==> values ", periods);
    console.log(" periods ==> invoicefilter", invoicefilter);
    getInvoiceFilterList();
  }, [applyFilterFlag, invoicefilter]);

  function getStatusPriority(statusId) {
    if (!statusId) return -1; // Handles empty StatusId
    const statuses = statusId.split(",").map((id) => id.trim());
    return Math.max(...statuses.map((id) => statusOrder[id] || -1)); // Use a low number for undefined statuses
  }

  const sortedLocationList = useMemo(() => {
    if (invoiceOrderBy) {
      return [...periods].sort((a, b) => {
        if (invoiceOrderBy === "Status") {
          const valueA = a[invoiceOrderBy]?.toLowerCase();
          const valueB = b[invoiceOrderBy]?.toLowerCase();

          if (invoiceOrder === "asc") {
            return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
          } else {
            return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
          }
        } else if (invoiceOrderBy === "BrokerCount") {
          const valueA = parseFloat(a[invoiceOrderBy]);
          const valueB = parseFloat(b[invoiceOrderBy]);
          console.log(valueA, valueB, "valueA - valueB");
          return invoiceOrder === "asc" ? valueA - valueB : valueB - valueA;
        } else if (invoiceOrderBy === "StatusId") {
          const priorityA = getStatusPriority(a[invoiceOrderBy]);
          const priorityB = getStatusPriority(b[invoiceOrderBy]);

          if (invoiceOrder === "asc") {
            return priorityA - priorityB;
          } else {
            return priorityB - priorityA;
          }

          // const valueA = a[invoiceOrderBy]?.toLowerCase();
          // const valueB = b[invoiceOrderBy]?.toLowerCase();

          // console.log("invoiceOrderBy valueA", valueA)
          // console.log("invoiceOrderBy valueA", valueB)

          // if (invoiceOrder === "asc") {
          //   return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
          // } else {
          //   return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
          // }
        } else {
          const valueA = a[invoiceOrderBy]?.toLowerCase();
          const valueB = b[invoiceOrderBy]?.toLowerCase();

          if (invoiceOrder === "asc") {
            return valueA < valueB ? -1 : valueA > valueB ? 1 : 0;
          } else {
            return valueA > valueB ? -1 : valueA < valueB ? 1 : 0;
          }
        }
      });
    }
    return periods;
  }, [periods, invoiceOrderBy, invoiceOrder]);

  const handleLocationSortRequest = (property) => {
    const isAsc = invoiceOrderBy === property && invoiceOrder === "asc";
    if (invoiceOrderBy === property && invoiceOrder === "desc") {
      setInvoiceOrder("");
      setInvoiceOrderBy("");
      dispatch({
        type: SORT_PARAMS,
        payload: { order: "", orderBy: "" },
      });
    } else {
      setInvoiceOrder(isAsc ? "desc" : "asc");
      setInvoiceOrderBy(property);
      dispatch({
        type: SORT_PARAMS,
        payload: { order: isAsc ? "desc" : "asc", orderBy: property },
      });
    }
  };

  const getLocationSortIcon = (orderByValue) => {
    if (invoiceOrderBy === orderByValue) {
      return invoiceOrder === "asc" ? (
        <img src={sortuparrowIcon} className="sort-table-icon-up-down" />
      ) : (
        <img src={sortdownarrowIcon} className="sort-table-icon-up-down" />
      );
    } else {
      return <img src={sortupdownarrowIcon} className="sort-table-icon-both" />;
    }
  };

  useEffect(() => {
    if (currentSort) {
      setInvoiceOrder(currentSort.order);
      setInvoiceOrderBy(currentSort.orderBy);
    }
  }, [currentSort]);

  const handleDebouncedClick = async (period, index) => {
    console.log("handleDebouncedClick", period);
    let data = {
      projectId: period.ProjectID.toString(),
      periodKey: period.PeriodKey,
    };

    const getAdminInvoiceStatementResponse =
      await getAdminInvoiceStatementByIdByInvoiceList(data);

    var isAdminGeneratedHaveEntry = false;
    var uniqueAdminDirectCreation = [];
    var uniqueadminSingleInvoiceDirectCreation = [];

    if (
      getAdminInvoiceStatementResponse &&
      getAdminInvoiceStatementResponse.ConsolidatedDetails &&
      getAdminInvoiceStatementResponse.ConsolidatedDetails.length > 0
    ) {
      uniqueAdminDirectCreation =
        getAdminInvoiceStatementResponse.ConsolidatedDetails.filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (t) =>
                t.ConsolidatedInvoiceId === item.ConsolidatedInvoiceId &&
                t.ConsolidatedProjectId === item.ConsolidatedProjectId &&
                t.ConsolidatedPeriodKey === item.ConsolidatedPeriodKey
            )
        );
    }

    if (
      getAdminInvoiceStatementResponse &&
      getAdminInvoiceStatementResponse.billingStatementDetails &&
      getAdminInvoiceStatementResponse.billingStatementDetails.length > 0
    ) {
      uniqueadminSingleInvoiceDirectCreation =
        getAdminInvoiceStatementResponse.billingStatementDetails.filter(
          (item, index, self) =>
            index ===
            self.findIndex(
              (t) =>
                t.InvoiceId === item.InvoiceId &&
                t.ProjID === item.ProjID &&
                t.PeriodKey === item.PeriodKey
            )
        );
    }

    if (
      uniqueAdminDirectCreation.length > 0 ||
      uniqueadminSingleInvoiceDirectCreation.length > 0
    ) {
      isAdminGeneratedHaveEntry = true;
    }

    if (isClickable) {
      handleInvoiceSingleRoWCreate(period, isAdminGeneratedHaveEntry);
      setPeriodValues(period);
      setPeriodIndexValues(index);
      setIsClickable(false);
      // Allow click after 3 seconds
      setTimeout(() => {
        setIsClickable(true);
      }, 1000);
    } else {
      setPeriodValues({});
      setPeriodIndexValues(0);
      console.log("Please wait before clicking again.", isClickable);
    }
  };

  return (
    <>
      <Box sx={{ display: "-webkit-box" }}>
        <Sidebar higlightSide={"5"} />

        <Box component="main" sx={{ flexGrow: 1, p: "18px 20px" }}>
          <Navbar title="Invoices" backFlag={false} backRoute={""} />

          {/* Filter Section */}
          <Box sx={{ p: "17px 24px", pt: "17px" }} className="bg-box user-log">
            <p
              style={{ marginBottom: "20px", fontWeight: "400" }}
              className="label"
            >
              Select a project to view, edit, and create Invoices.{" "}
              <span
                onClick={() => {
                  setInvoiceHelp(true);
                }}
                style={{
                  fontSize: "16px",
                  cursor: "pointer",
                  position: "absolute",
                  color: "#898989",
                }}
                class="material-symbols-outlined"
              >
                help
              </span>
            </p>
            <Grid className="invoice-list-filter" container>
              <Grid
                sx={{
                  pr: { xs: "0", md: "30px" },
                  opacity: billingStatmentLoading == true ? 0.5 : 1, // Reduce opacity to indicate disabled state
                  pointerEvents:
                    billingStatmentLoading == true ? "none" : "auto", // Prevent interaction
                }}
                xs={12}
                md={6}
              >
                {/* Customer Status */}
                <Box>
                  <p style={{ marginBottom: "0px" }} className="label oh-label">
                    Customer
                  </p>
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="customerStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "customerStatus",
                            "all"
                          )
                        }
                        checked={filter.customerStatus === "" ? true : false}
                        sx={{ color: "gray" }}
                      />
                    }
                    label="All"
                  />

                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="customerStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "customerStatus",
                            "yes"
                          )
                        }
                        checked={filter.customerStatus === true ? true : false}
                        sx={{ color: "gray" }}
                        disabled={billingStatmentLoading == true}
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="customerStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "customerStatus",
                            "no"
                          )
                        }
                        checked={filter.customerStatus === false ? true : false}
                        sx={{ color: "gray" }}
                      />
                    }
                    label="Inactive"
                  />
                  <FormControl sx={{ width: "100%" }} variant="standard">
                    <Autocomplete
                      sx={{
                        width: "100%",
                        fontSize: '14px !important',
                        // "& .MuiAutocomplete-inputRoot": {
                        //   paddingRight: "10px !important",
                        // },
                        "& .MuiAutocomplete-input": {
                          color:
                            filter.userId === ""
                              ? "#212121 !important"
                              : "#212121 !important",
                              fontSize: '14px !important',
                          // height: '25px !important'
                        },
                      }}
                      options={userList || []} // List of options
                      getOptionLabel={(option) => option?.Name || ""} // Display the customer name
                      isOptionEqualToValue={(option, value) =>
                        option.UserId === value.UserId
                      } // Compare by user ID
                      value={
                        userList.find(
                          (item) => item.UserId === filter.userId
                        ) || null
                      }
                      onChange={(event, newValue) => {
                        if (newValue) {
                          setFilter((prevState) => ({
                            ...prevState,
                            userId: newValue.UserId,
                            projectId: "",
                          }));
                          dispatch({
                            type: types.INVOICE_LIST_SELECT,
                            payload: {
                              ...filter,
                              userId: newValue.UserId,
                              projectId: "",
                            },
                          });
                          setProjectList([]);
                          setProjectListDropdown([]);
                          setSelectedProjects([]);
                          getProjectList(newValue.UserId, newValue);
                        } else {
                          // Reset the filter when the value is cleared
                          setFilter((prevState) => ({
                            ...prevState,
                            userId: "",
                            projectId: "",
                          }));
                          dispatch({
                            type: types.INVOICE_LIST_SELECT,
                            payload: {
                              ...filter,
                              userId: "",
                              projectId: "",
                            },
                          });
                          setProjectList([]);
                          setProjectListDropdown([]);
                          setSelectedProjects([]);
                        }
                      }}
                      renderInput={(params) => (
                        <TextField
                          {...params}
                          placeholder="Search Customer"
                          variant="outlined"
                          size="large"
                          sx={{
                            height: "25px !imporatant",
                            color: "#212121 !important",
                            fontSize: '14px !important',
                          }}
                        />
                      )}
                      renderOption={(props, option) => (
                        <li
                          style={{ color: "#212121 !important", fontSize: '14px', fontWeight: 400 }}
                          {...props}
                          key={option.UserId}
                        >
                          {option.Name}
                        </li>
                      )}
                      noOptionsText="No options"
                    />
                  </FormControl>
                </Box>
              </Grid>

              <Grid
                sx={{
                  pl: { xs: "0", md: "30px" },
                  opacity: filter.userId === "" ? 0.5 : 1, // Reduce opacity to indicate disabled state
                  pointerEvents: filter.userId === "" ? "none" : "auto", // Prevent interaction
                }}
                xs={12}
                md={6}
              >
                {/* Project Status */}
                <Box>
                  <p style={{ marginBottom: "0px" }} className="label oh-label">
                    Project
                  </p>
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="projectStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "projectStatus",
                            "all"
                          )
                        }
                        checked={filter.projectStatus === "" ? true : false}
                        disabled={filter.userId === ""} // Conditionally disable
                        sx={{ color: "gray" }}
                      />
                    }
                    label="All"
                  />

                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="projectStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "projectStatus",
                            "yes"
                          )
                        }
                        checked={filter.projectStatus === true ? true : false}
                        disabled={filter.userId === ""} // Conditionally disable
                        sx={{ color: "gray" }}
                      />
                    }
                    label="Active"
                  />
                  <FormControlLabel
                    className="checkbox"
                    control={
                      <Checkbox
                        name="projectStatus"
                        onChange={() =>
                          handleCustomerProjectStatusChange(
                            "projectStatus",
                            "no"
                          )
                        }
                        checked={filter.projectStatus === false ? true : false}
                        disabled={filter.userId === ""} // Conditionally disable
                        sx={{ color: "gray" }}
                      />
                    }
                    label="Inactive"
                  />
                </Box>
                <FormControl
                  sx={{ width: "100%" }}
                  variant="standard"
                  disabled={filter.userId === ""} // Conditionally disable
                >
                  <Autocomplete
                    multiple
                    id="checkboxes-tags-demo"
                    options={projectList.filter((project) =>
                      filter.projectStatus === ""
                        ? true
                        : filter.projectStatus === true
                        ? project.Active === 1
                        : filter.projectStatus === false
                        ? project.Active === 0
                        : true
                    )}
                    disableCloseOnSelect
                    IconComponent={KeyboardArrowDownIcon}
                    limitTags={1}
                    disabled={filter.userId === ""} // Conditionally disable
                    getOptionLabel={(option) => option.Name}
                    // filterOptions={(options, { inputValue }) => {
                    //   let filteredOptions = options;

                    //   // Filter based on projectStatus
                    //   if (filter.projectStatus === true) {
                    //     // Show active projects (Active == 1)
                    //     filteredOptions = options.filter(
                    //       (option) => option.Active === 1
                    //     );
                    //   } else if (filter.projectStatus === false) {
                    //     // Show inactive projects (Active == 0)
                    //     filteredOptions = options.filter(
                    //       (option) => option.Active === 0
                    //     );
                    //   }

                    //   // Further filter by inputValue for search
                    //   if (inputValue.trim() !== "") {
                    //     filteredOptions = filteredOptions.filter((option) =>
                    //       option.Name.toLowerCase().includes(
                    //         inputValue.toLowerCase()
                    //       )
                    //     );
                    //   }

                    //   return filteredOptions;
                    // }}
                    onChange={handleSearchOnChange}
                    value={selectedProject}
                    renderTags={() => null}
                    renderOption={(props, option, { selected }) => {
                      const isSelected = selectedProject.some(
                        (project) => project.ProjectId === option.ProjectId
                      );

                      return (
                        <li {...props} key={option.ProjectId}>
                          <Checkbox
                            icon={icon}
                            checkedIcon={checkedIcon}
                            style={{ marginRight: 8 }}
                            checked={isSelected}
                          />
                          <span className="select-option-text">
                            {option.Name}
                          </span>
                        </li>
                      );
                    }}
                    renderInput={(params) => (
                      <TextField
                        {...params}
                        variant="outlined"
                        placeholder="Search Projects"
                      />
                    )}
                  />
                </FormControl>

                <Stack direction="row" spacing={2}>
                  <div>
                    {selectedProject.map((option) => (
                      <Chip
                        key={option.ProjectId}
                        label={option.Name}
                        onDelete={() => {
                          handleSearchDeleteOnChange(option.ProjectId);
                        }}
                        style={{ margin: 5 }}
                      />
                    ))}
                  </div>
                </Stack>
              </Grid>
            </Grid>
          </Box>

          {/* Display Billing Periods */}
          {isInvoiceSearch ? (
            <Box
              sx={{
                background: "#fff",
                padding: "25px 24px",
                mt: "15px",
                pt: "16px",
              }}
              className="secound-bg-box user-log"
            >
              <Grid container>
                <Grid xs={12} md={12}>
                  {/* Actions */}
                  <Stack
                    sx={{
                      float: { xs: "left", md: "right" },
                      alignItems: { xs: "flex-start", md: "center" },
                      marginTop: "0px",
                      marginBottom: "16px",
                    }}
                    direction={{ xs: "column", sm: "row" }}
                    spacing={1}
                  >
                    {(invoicefilter.billingStartDate ||
                      invoicefilter.billingEndDate ||
                      invoicefilter.invoiceStatus) &&
                    applyFilterFlag ? (
                      <Button
                        startIcon={
                          <span class="material-symbols-outlined">close</span>
                        }
                        className="clear-btn"
                        variant="contained"
                        onClick={clearBillingFilterFunc}
                      >
                        Clear Filter
                      </Button>
                    ) : (
                      ""
                    )}

                    {/* Filter Button */}
                    <Stack
                      className="filter"
                      sx={{ float: "right" }}
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      onClick={filterOpenFun}
                    >
                      <span class="material-symbols-outlined">filter_list</span>
                      <Typography>Filter</Typography>
                    </Stack>

                    <Stack
                      sx={{ float: "right" }}
                      direction="row"
                      spacing={1}
                      alignItems="center"
                    >
                      <Button
                        startIcon={
                          <span class="material-symbols-outlined">add</span>
                        }
                        onClick={consolidateInvoiceFun}
                        className={
                          invoiceCheckBox && invoiceCheckBox?.length > 1
                            ? "primary-btn"
                            : "consolidate-disabled-btn"
                        }
                        variant="contained"
                        color="success"
                        disabled={
                          invoiceCheckBox && invoiceCheckBox?.length > 1
                            ? false
                            : true
                        }
                      >
                        Create Consolidated Invoice
                      </Button>
                    </Stack>
                  </Stack>

                  {/* Billing Periods Table */}
                  <TableContainer
                    className="invoice-table"
                    sx={{
                      boxShadow: "none",
                      maxHeight: { xs: 440, md: 440, lg: 400, xl: 527 },
                    }}
                    component={Paper}
                  >
                    <Table
                      stickyHeader
                      sx={{ minWidth: 650 }}
                      aria-label="sticky table"
                    >
                      <TableHead>
                        <TableRow>
                          <TableCell className="invoice-table-checkbox">
                            <FormControlLabel
                              className="checkbox"
                              control={
                                <Tooltip
                                  title="Selects all statements that are in 'Statement Ready' status."
                                  arrow
                                  placement="top"
                                >
                                  <Checkbox
                                    name="invoiceStatus"
                                    onChange={() =>
                                      handleInvoiceCheckBoxChange("all")
                                    }
                                    checked={
                                      invoiceCheckBoxAll === "all"
                                        ? true
                                        : false
                                    }
                                    // checked={
                                    //   consoldiateCheckBoxFilter?.invoiceAllSelectCheckbox ===
                                    //     "all" &&
                                    //   (() => {
                                    //     const matchedArrayAll = periods
                                    //       .filter((item) => {
                                    //         if (item.StatusId) {
                                    //           const trimmedStatusArr =
                                    //             item.StatusId.split(",").map(
                                    //               (str) => str.trim()
                                    //             );
                                    //           return trimmedStatusArr.includes(
                                    //             "2"
                                    //           );
                                    //         }
                                    //         return false;
                                    //       })
                                    //       .map(
                                    //         (item) => item.BillingStatemrntId
                                    //       );

                                    //     return matchedArrayAll.length > 0; // Check if greater than zero
                                    //   })()
                                    //     ? true
                                    //     : false
                                    // }
                                    sx={{ color: "gray" }}
                                    disabled={(() => {
                                      const matchedArrayAll = periods
                                        .filter((item) => {
                                          if (item.StatusId) {
                                            const trimmedStatusArr =
                                              item.StatusId.split(",").map(
                                                (str) => str.trim()
                                              );
                                            return trimmedStatusArr.includes(
                                              "2"
                                            ); // Check if "2" is included
                                          }
                                          return false;
                                        })
                                        .map((item) => item.BillingStatemrntId);

                                      return matchedArrayAll.length === 0; // Disable if no matches found
                                    })()}
                                  />
                                </Tooltip>
                              }
                              label=""
                            />
                            <TableSortLabel
                              active={invoiceOrderBy === "ProjectName"}
                              direction={
                                invoiceOrderBy === "ProjectName"
                                  ? invoiceOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("ProjectName")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("ProjectName")
                              }
                              style={
                                invoiceOrderBy === "ProjectName"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Project Name
                            </TableSortLabel>
                          </TableCell>
                          {/* <TableCell></TableCell> */}
                          <TableCell>Billing Period</TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={invoiceOrderBy === "BrokerCount"}
                              direction={
                                invoiceOrderBy === "BrokerCount"
                                  ? invoiceOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("BrokerCount")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("BrokerCount")
                              }
                              style={
                                invoiceOrderBy === "BrokerCount"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              No of Brokers
                            </TableSortLabel>
                          </TableCell>
                          <TableCell>
                            <TableSortLabel
                              active={invoiceOrderBy === "StatusId"}
                              direction={
                                invoiceOrderBy === "StatusId"
                                  ? invoiceOrder
                                  : "asc"
                              }
                              onClick={() =>
                                handleLocationSortRequest("StatusId")
                              }
                              IconComponent={() =>
                                getLocationSortIcon("StatusId")
                              }
                              style={
                                invoiceOrderBy === "StatusId"
                                  ? { color: "#007fff" }
                                  : {}
                              }
                            >
                              Status
                            </TableSortLabel>
                          </TableCell>
                        </TableRow>
                      </TableHead>
                      {/* <Grid className="invoice-listpage-loader"> */}
                      {loading ? <CustomPageLoading /> : ""}
                      {/* </Grid> */}
                      <TableBody>
                        {sortedLocationList.map((period, index) => {
                          console.log(period, "periiiiiiiiiiiiiiiiiiodddddd");
                          // Split and trim StatusId to check conditions
                          let StatusIdArray = period.StatusId.split(",");
                          let trimmedStatusArr = StatusIdArray.map((str) =>
                            str.trim()
                          );
                          // console.log(trimmedStatusArr, "trimmmmmmmmmmmmmm");
                          // console.log(
                          //   StatusIdArray,
                          //   "StatusIdArrayStatusIdArray"
                          // );
                          let Invoiceobj = {
                            StatementOpen: 0,
                            StatementReady: 0,
                            InvoiceStarted: 0,
                            InvoiceClosed: 0,
                          };

                          trimmedStatusArr.forEach((item) => {
                            switch (item) {
                              case StatementOpen:
                                Invoiceobj.StatementOpen++;
                                break;
                              case StatementReady:
                                Invoiceobj.StatementReady++;
                                break;
                              case InvoiceStarted:
                                Invoiceobj.InvoiceStarted++;
                                break;
                              case InvoiceClosed:
                                Invoiceobj.InvoiceClosed++;
                                break;
                              default:
                                // Handle unexpected values here if needed
                                break;
                            }
                          });

                          const statusIds = period?.StatusId?.split(",").map(
                            (id) => id?.trim()
                          );
                          const statmentIds = period?.statmentIds
                            ?.split(",")
                            .map((id) => id?.trim());

                          // Find all the statmentIds corresponding to StatusId '2'
                          const result = statmentIds
                            .filter((_, index) => statusIds[index] === "2")
                            .map((id) => Number(id));

                          const formattedString = result.map(Number).join(", ");

                          console.log(
                            "statmentIds for StatusId 2:",
                            result,
                            formattedString
                          );

                          const currentDate = new Date();
                          const currentMonth = currentDate.getMonth() + 1; // Months are zero-indexed, so +1 is necessary
                          const currentYear = currentDate.getFullYear();

                          return (
                            <TableRow key={index} style={{ cursor: "pointer" }}>
                              <TableCell
                                sx={{
                                  wordBreak: "break-all",
                                  maxWidth: "400px",
                                }}
                                onClick={(e) => {
                                  e.stopPropagation(); // This makes sure the click isn't blocked by other elements
                                  handleDebouncedClick(period, index);
                                }}
                              >
                                <div className="checkbox invoice-list-checkbox">
                                  <Checkbox
                                    name="invoiceStatus"
                                    onChange={() =>
                                      handleInvoiceCheckBoxChange(
                                        period.BillingStatemrntId
                                      )
                                    }
                                    checked={consoldiateCheckBoxFilter?.invoiceSingleCheckBox?.includes(
                                      period.BillingStatemrntId
                                    )}
                                    sx={{ color: "gray" }}
                                    disabled={
                                      Invoiceobj.StatementReady ? false : true
                                    }
                                    style={
                                      Invoiceobj.StatementReady
                                        ? {}
                                        : { background: "#f0f2f5" }
                                    }
                                    onClick={(event) => {
                                      event.stopPropagation(); // Stop the event from affecting the checkbox
                                      // handleDebouncedClick(period, index);
                                    }}
                                  />
                                  <span
                                    style={{
                                      marginLeft: "0px",
                                      cursor: "pointer",
                                    }}
                                    onClick={(event) => {
                                      event.stopPropagation(); // Stop the event from affecting the checkbox
                                      handleDebouncedClick(period, index);
                                    }}
                                  >
                                    {period.ProjectName}
                                  </span>
                                </div>
                              </TableCell>
                              {/* <TableCell
                                onClick={() =>
                                  handleInvoiceSingleRoWCreate(period)
                                }
                              >
                                {period.ProjectName}
                              </TableCell> */}
                              <TableCell
                                onClick={() =>
                                  handleDebouncedClick(period, index)
                                }
                              >
                                <span
                                    className={
                                      (currentYear > period.currentYear || 
                                        (currentYear === period.currentYear && currentMonthNumber > period.currentMonthNumberInvoice)
                                      ) && Invoiceobj.StatementReady
                                        ? "ribbon-box"
                                        : (currentYear === period.currentYear &&
                                          currentMonthNumber === period.currentMonthNumberInvoice &&
                                          Invoiceobj.StatementReady)
                                        ? "ribbon-box-active"
                                        : ""
                                    }
                                >
                                  {moment
                                    .utc(`${period.BillingStart}`)
                                    .format("MM/DD/YYYY")}
                                  {" - "}
                                  {moment
                                    .utc(`${period.BillingEnd}`)
                                    .format("MM/DD/YYYY")}
                                    {/* {period?.BillingDate || '-'} */}
                                </span>
                              </TableCell>
                              <TableCell
                                onClick={() =>
                                  handleDebouncedClick(period, index)
                                }
                              >
                                {period.BrokerCount}
                              </TableCell>
                              <TableCell
                              // onClick={() =>
                              //   handleInvoiceSingleRoWCreate(period)
                              // }
                              >
                                {period.isNotYetStarted ? (
                                  <>
                                    <span
                                      aria-owns={
                                        opens5
                                          ? "mouse-over-popover"
                                          : undefined
                                      }
                                      aria-haspopup="true"
                                      onMouseEnter={handlePopoverOpen5}
                                      onMouseLeave={handlePopoverClose5}
                                      className="not-started"
                                      onClick={() =>
                                        handleInvoiceBrokerCount(
                                          period,
                                          Invoiceobj,
                                          0
                                        )
                                      }
                                    >
                                      {period.notYetStartedDetail
                                        ? period.notYetStartedDetail.BrokerCount
                                        : 0}
                                    </span>

                                    <Popover
                                      className="invoice-popover"
                                      id="mouse-over-popover"
                                      sx={{
                                        pointerEvents: "none",
                                      }}
                                      open={opens5}
                                      anchorEl={anchorEl5}
                                      anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                      }}
                                      transformOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                      }}
                                      onClose={handlePopoverClose5}
                                      disableRestoreFocus
                                    >
                                      <span className="invoice-popover-chip not-started">
                                        Not Started
                                      </span>
                                    </Popover>
                                  </>
                                ) : (
                                  ""
                                )}

                                {Invoiceobj.StatementOpen ? (
                                  <>
                                    <span
                                      aria-owns={
                                        opens1
                                          ? "mouse-over-popover"
                                          : undefined
                                      }
                                      aria-haspopup="true"
                                      onMouseEnter={handlePopoverOpen1}
                                      onMouseLeave={handlePopoverClose1}
                                      className="invoice-ready"
                                      onClick={() =>
                                        handleInvoiceBrokerCount(
                                          period,
                                          Invoiceobj,
                                          1
                                        )
                                      }
                                    >
                                      {Invoiceobj.StatementOpen}
                                    </span>

                                    <Popover
                                      className="invoice-popover"
                                      id="mouse-over-popover"
                                      sx={{
                                        pointerEvents: "none",
                                      }}
                                      open={opens1}
                                      anchorEl={anchorEl1}
                                      anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                      }}
                                      transformOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                      }}
                                      onClose={handlePopoverClose1}
                                      disableRestoreFocus
                                    >
                                      <span className="invoice-popover-chip invoice-ready">
                                        Statement Pending
                                      </span>
                                      {/* <Box className="arrow-shape"></Box> */}
                                    </Popover>
                                  </>
                                ) : (
                                  ""
                                )}

                                {Invoiceobj.StatementReady ? (
                                  <>
                                    <span
                                      aria-owns={
                                        opens2
                                          ? "mouse-over-popover"
                                          : undefined
                                      }
                                      aria-haspopup="true"
                                      onMouseEnter={handlePopoverOpen2}
                                      onMouseLeave={handlePopoverClose2}
                                      className="invoice-open"
                                      onClick={() =>
                                        handleInvoiceBrokerCount(
                                          period,
                                          Invoiceobj,
                                          2
                                        )
                                      }
                                    >
                                      {Invoiceobj.StatementReady}
                                    </span>

                                    <Popover
                                      className="invoice-popover"
                                      id="mouse-over-popover"
                                      sx={{
                                        pointerEvents: "none",
                                      }}
                                      open={opens2}
                                      anchorEl={anchorEl2}
                                      anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                      }}
                                      transformOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                      }}
                                      onClose={handlePopoverClose2}
                                      disableRestoreFocus
                                    >
                                      <span className="invoice-popover-chip invoice-open">
                                        Statement Ready
                                      </span>
                                    </Popover>
                                  </>
                                ) : (
                                  ""
                                )}

                                {Invoiceobj.InvoiceStarted ? (
                                  <>
                                    <span
                                      aria-owns={
                                        opens3
                                          ? "mouse-over-popover"
                                          : undefined
                                      }
                                      aria-haspopup="true"
                                      onMouseEnter={handlePopoverOpen3}
                                      onMouseLeave={handlePopoverClose3}
                                      className="invoice-started"
                                      onClick={() =>
                                        handleInvoiceBrokerCount(
                                          period,
                                          Invoiceobj,
                                          3
                                        )
                                      }
                                    >
                                      {Invoiceobj.InvoiceStarted}
                                    </span>

                                    <Popover
                                      className="invoice-popover"
                                      id="mouse-over-popover"
                                      sx={{
                                        pointerEvents: "none",
                                      }}
                                      open={opens3}
                                      anchorEl={anchorEl3}
                                      anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                      }}
                                      transformOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                      }}
                                      onClose={handlePopoverClose3}
                                      disableRestoreFocus
                                    >
                                      <span className="invoice-popover-chip invoice-started">
                                        Invoice Started
                                      </span>
                                    </Popover>
                                  </>
                                ) : (
                                  ""
                                )}

                                {Invoiceobj.InvoiceClosed ? (
                                  <>
                                    <span
                                      aria-owns={
                                        opens4
                                          ? "mouse-over-popover"
                                          : undefined
                                      }
                                      aria-haspopup="true"
                                      onMouseEnter={handlePopoverOpen4}
                                      onMouseLeave={handlePopoverClose4}
                                      className="invoice-closed"
                                      onClick={() =>
                                        handleInvoiceBrokerCount(
                                          period,
                                          Invoiceobj,
                                          4
                                        )
                                      }
                                    >
                                      {Invoiceobj.InvoiceClosed}
                                    </span>

                                    <Popover
                                      className="invoice-popover"
                                      id="mouse-over-popover"
                                      sx={{
                                        pointerEvents: "none",
                                      }}
                                      open={opens4}
                                      anchorEl={anchorEl4}
                                      anchorOrigin={{
                                        vertical: "top",
                                        horizontal: "center",
                                      }}
                                      transformOrigin={{
                                        vertical: "bottom",
                                        horizontal: "center",
                                      }}
                                      onClose={handlePopoverClose4}
                                      disableRestoreFocus
                                    >
                                      <span className="invoice-popover-chip invoice-closed">
                                        Invoice Closed
                                      </span>
                                    </Popover>
                                  </>
                                ) : (
                                  ""
                                )}

                                {/*
                              {Invoiceobj.InvoiceClosed ? (
                              <Tooltip
                              className="invoice-tooltip"
                              title={"Invoice Closed"}
                              >
                              <span className="invoice-closed">
                              {Invoiceobj.InvoiceClosed}
                              </span>
                              </Tooltip>
                              ) : (
                              ""
                              )} */}
                              </TableCell>
                            </TableRow>
                          );
                        })}
                      </TableBody>
                    </Table>
                    <br />
                    {/* {!loading && total > 0 && (
                      <Pagination
                        variant="outlined"
                        shape="rounded"
                        count={total}
                        page={page}
                        onChange={handlePageChange}
                      />
                    )} */}
                  </TableContainer>
                  {!loading && periods && periods.length == 0 ? (
                    <NoRecordFound />
                  ) : (
                    <></>
                  )}
                  {/* Create Billing Confirm Dialog */}
                  {open && (
                    <CreateBillingConfirm
                      open={open}
                      createBilling={createBilling}
                    />
                  )}

                  {/* Billing Statement Filter */}
                  {openFilter && (
                    <InvoiceFilter
                      open={openFilter}
                      handleClose={filterClose}
                      filter={invoicefilter}
                      setFilter={setInvoicefilter}
                      filterInitial={invoiceFilterInitial}
                      submitFilter={submitFilter}
                    />
                  )}

                  {consolidateInvoiceModel && (
                    <CreateConsolidatedInvoice
                      open={consolidateInvoiceModel}
                      handleCloseInvoice={handleCloseInvoice}
                      createCloseInvoice={createCloseInvoice}
                      selectedPeriod={selectedPeriod}
                      selectedInvoicePeriod={selectedInvoicePeriod}
                      adminDirectCreation={adminDirectCreation}
                      adminSingleInvoiceDirectCreation={
                        adminSingleInvoiceDirectCreation
                      }
                      invoiceClosedList={invoiceClosedList}
                      periodIndexValues={periodIndexValues}
                      handleModelPopupInvoiceReload={
                        handleModelPopupInvoiceReload
                      }
                    />
                  )}

                  {/* {consolidatedComponent && (
                    <ConsolidatedInvoice
                      getInvoiceFilterList={getInvoiceFilterList}
                    />
                  )} */}

                  {createBillingPeriodModel && (
                    <CreateBillingPeriodInvoice
                      open={createBillingPeriodModel}
                      createCloseBillingPeriod={createCloseBillingPeriod}
                      selectedInvoicePeriod={selectedInvoicePeriod}
                      createBillingInvoice={createBillingInvoice}
                    />
                  )}

                  {viewInvoiceBrokerModel && (
                    <ViewInvoiceBroker
                      open={viewInvoiceBrokerModel}
                      setViewInvoiceBrokerModel={setViewInvoiceBrokerModel}
                      viewInvoiceBrokerDetail={viewInvoiceBrokerDetail}
                    />
                  )}
                </Grid>
              </Grid>
            </Box>
          ) : (
            <Box className="secound-bg-box user-log">
              <Grid container>
                <Box
                  sx={{
                    textAlign: "center",
                    width: "100%",
                    background: "#fff",
                    marginTop: "15px",
                    borderRadius: "5px",
                  }}
                >
                  {loading ? <CustomPageLoading /> : ""}
                  <img
                    style={{ width: "100%", maxWidth: "326px" }}
                    src={BillingNodata}
                  />
                  <p
                    style={{ marginTop: "15px", marginBottom: "50px" }}
                    className="no-data-text"
                  >
                    Please select a{" "}
                    <span style={{ color: "#58A84A" }}>customer</span> and{" "}
                    <span style={{ color: "#58A84A" }}>project</span> to view
                    the invoices.
                  </p>
                </Box>
              </Grid>
            </Box>
          )}
          {InvoiceHelpButton ? (
            <InvoiceHelpInfoModel
              open={InvoiceHelpButton}
              setInvoiceHelp={setInvoiceHelp}
            />
          ) : (
            ""
          )}
        </Box>
      </Box>
    </>
  );
}
